<template>
  <div>
    <v-row no-glutters class="body-rows">
      <v-col cols="12" md="7" class="left-cols1 pr-md-8">
        <p class="subtitle-2 font-weight-bold mb-2 mb-md-5 txt-666">
          <v-btn to="/signature" icon><v-icon>mdi-arrow-left</v-icon></v-btn> Step 5 of 6
        </p>
        <p v-if="nomis == 0" class="headline font-weight-black mb-2">Would you like to add nominee for your investment?
        </p>
        <p v-if="nomis == 1" class="headline font-weight-black mb-2">Add Nominee Details</p>

        <p class="subtitle-1 font-weight-regular txt-666">Secure your investments for the future by adding up to 3
          nominees.<br> Example - You can split percentages like 40%, 25%, and 35% among them.</p>
        <v-alert v-if="rejectdata.app_status == 'rejected' ? rejectdata.stage_wise_approval.nominee == 'no' : ''"
          border="left" colored-border type="info" style="border: 1px solid #ebeef0 !important"
          class="mt-4 mx-auto rounded-xl text-left py-2" color="warning" elevation="0">
          <span class="subtitle-2 font-weight-regular">Your Nominee have been rejected due <b>{{
            rejectdata.nominee_reject_reason ? rejectdata.nominee_reject_reason : "" }}</b></span>
        </v-alert>
        <v-alert v-if="nomineeclearalert" border="left" colored-border type="error" style="border: 1px solid #ebeef0 !important" class="mt-4 mx-auto rounded-xl text-left py-2" color="error" elevation="0">
          <span class="subtitle-2 font-weight-regular">Your Nominee video has been cleared. Please re-record or add a nominee to continue.</span>
        </v-alert>
        <div v-if="!dataloader || !cardloader">
          <div v-if="mainnomineeselect == true">
            <v-chip-group v-if="nomis == 0" class="py-4" column>
              <v-chip :disabled="cardloader" @click="(nom = tag.val), nomineeUpdation()"
                :color="nom == tag.val ? '#000' : '#666666'" :text-color="nom == tag.val ? '#fff' : '#666666'"
                v-for="(tag, l) in noms" :outlined="nom != tag.val" :key="l">
                {{ tag.txt }}
              </v-chip>
            </v-chip-group>
          </div>
          <div v-if="showHypervergeFlow == true">
            <v-alert color="#F5F5F7" elevation="0" class="pa-4 rounded-xl">


              <p class="subtitle-1 font-weight-regular black--text mt-4">
                As per <strong>SEBI regulations</strong>, opting-out requires a short video confirmation.
                <br> Please record a quick verification video by allowing camera access, then click
                <strong>Start Recording</strong> and clearly say the 4-digit number shown on the screen.
                <br> Ensure to finish within <strong> 5 - 10 seconds</strong> — the recording will auto-stop
                if it exceeds the limit.
                <br><br>
                Click below to start the video capture as per SEBI guidelines.
              </p>
            </v-alert>

            <v-btn large @click="showHypervergeFlow = false; mainnomineeselect = true" color="#000"
              class="white--text text-none rounded-pill elevation-0">
              <span class="white--text subtitle-1 font-weight-medium px-6">Go Back to Fill Nominee Details</span>
            </v-btn>
            <v-btn large @click="connecthypervegefun()" :loading="hyperflowloadd" color="#000"
              class="white--text smalldev text-none rounded-pill ml-4 mt-lg-6 mt-sm-6 mt-xl-0  mt-md-6 elevation-0">
              <span class="white--text subtitle-1 font-weight-medium  px-6">Proceed to Video Capture</span>
            </v-btn>

          </div>
          <div v-if="hypervergeresult == true">
            <p class="title font-weight-regular green--text">🎉 Video Captured Successfully
            </p>

            <v-alert border="left" colored-border type="info" style="border: 1px solid #ebeef0 !important"
              class="mt-4 mx-auto rounded-xl text-left mb-4 py-2" color="warning" elevation="0">
              <span class="subtitle-2 font-weight-regular">Your video has been
                saved.
                As mandated by SEBI, it will be used only to validate your opt-out request and kept securely.</span>
            </v-alert>
            <v-btn large @click="clearNomineeVideo()"
              color="#000" class="white--text text-none rounded-pill elevation-0">
              <span class="white--text subtitle-1 font-weight-medium px-6">Clear the video and fill the nominee
                details.</span>
            </v-btn>
            <v-btn large @click="hypervergetsta()" color="#000"
              class="white--text ml-4 text-none rounded-pill smalldev mt-lg-6 mt-sm-14 mt-xl-0   mt-md-6 elevation-0">
              <span class="white--text subtitle-1 font-weight-medium px-6">Continue</span>
            </v-btn>
          </div>

          <div v-if="nomis == 1">
            <v-alert v-if="boPrefillNotice == 'filled'" border="left" colored-border type="info"
              style="border: 1px solid #ebeef0 !important" class="mt-2 mb-4 mx-auto rounded-xl text-left py-2" color="info"
              elevation="0">
              <span class="subtitle-2 font-weight-regular">We've <b>filled in your nominee details</b> from our records to save you time. Please <b>review them</b>, make any changes you need, and continue. If you'd prefer not to have a nominee, you can <b>opt out</b> instead. As per <b>SEBI rules</b>, opting out needs a <b>short video confirmation</b>.</span>
            </v-alert>
            <v-chip-group column class="mb-4">
              <v-chip @click="panel = 0" :color="panel == 0 ? '#000' : '#666666'"
                :text-color="panel == 0 ? '#fff' : '#666666'" :outlined="panel != 0">
                1st nominee
                <div v-if="!$v.nominee1.$invalid" class="mt-1 ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z"
                      fill="#34A853" />
                  </svg>
                </div>
                <v-card v-if="activetab == ''" color="transparent" @click="clearTabo()" class="mt-1 ml-2 elevation-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.3333 5.99984L7.33333 9.99984M7.33333 5.99984L11.3333 9.99984M1.81333 8.63984L4.69333 12.4798C4.928 12.7927 5.04533 12.9492 5.19403 13.062C5.32574 13.1619 5.47488 13.2365 5.63385 13.2819C5.81334 13.3332 6.00889 13.3332 6.4 13.3332H11.4667C12.5868 13.3332 13.1468 13.3332 13.5746 13.1152C13.951 12.9234 14.2569 12.6175 14.4487 12.2412C14.6667 11.8133 14.6667 11.2533 14.6667 10.1332V5.8665C14.6667 4.7464 14.6667 4.18635 14.4487 3.75852C14.2569 3.3822 13.951 3.07624 13.5746 2.88449C13.1468 2.6665 12.5868 2.6665 11.4667 2.6665H6.4C6.00889 2.6665 5.81334 2.6665 5.63385 2.71776C5.47488 2.76317 5.32574 2.83774 5.19403 2.93767C5.04533 3.05051 4.928 3.20695 4.69333 3.51984L1.81333 7.35984C1.6412 7.58934 1.55514 7.7041 1.52196 7.83013C1.49268 7.94137 1.49268 8.0583 1.52196 8.16955C1.55514 8.29558 1.6412 8.41033 1.81333 8.63984Z"
                      :stroke="panel == 0 ? '#fff' : '#666666'" stroke-width="1.6" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </v-card>
              </v-chip>

              <v-chip @click="panel = 1" :color="panel == 1 ? '#000' : '#666666'"
                :text-color="panel == 1 ? '#fff' : '#666666'" :outlined="panel != 1"
                v-if="activetab == 'tab2' || activetab == 'tab3'">
                2nd nominee
                <div v-if="!$v.nominee2.$invalid" class="mt-1 ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z"
                      fill="#34A853" />
                  </svg>
                </div>
                <v-card v-if="activetab == 'tab2' && additionalNominees.length === 0" color="transparent"
                  @click="clearTabt()" class="mt-1 ml-2 elevation-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.3333 5.99984L7.33333 9.99984M7.33333 5.99984L11.3333 9.99984M1.81333 8.63984L4.69333 12.4798C4.928 12.7927 5.04533 12.9492 5.19403 13.062C5.32574 13.1619 5.47488 13.2365 5.63385 13.2819C5.81334 13.3332 6.00889 13.3332 6.4 13.3332H11.4667C12.5868 13.3332 13.1468 13.3332 13.5746 13.1152C13.951 12.9234 14.2569 12.6175 14.4487 12.2412C14.6667 11.8133 14.6667 11.2533 14.6667 10.1332V5.8665C14.6667 4.7464 14.6667 4.18635 14.4487 3.75852C14.2569 3.3822 13.951 3.07624 13.5746 2.88449C13.1468 2.6665 12.5868 2.6665 11.4667 2.6665H6.4C6.00889 2.6665 5.81334 2.6665 5.63385 2.71776C5.47488 2.76317 5.32574 2.83774 5.19403 2.93767C5.04533 3.05051 4.928 3.20695 4.69333 3.51984L1.81333 7.35984C1.6412 7.58934 1.55514 7.7041 1.52196 7.83013C1.49268 7.94137 1.49268 8.0583 1.52196 8.16955C1.55514 8.29558 1.6412 8.41033 1.81333 8.63984Z"
                      :stroke="panel == 1 ? '#fff' : '#666666'" stroke-width="1.6" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </v-card>
              </v-chip>

              <v-chip @click="panel = 2" :color="panel == 2 ? '#000' : '#666666'"
                :text-color="panel == 2 ? '#fff' : '#666666'" :outlined="panel != 2" v-if="activetab == 'tab3'">
                3rd nominee
                <div v-if="!$v.nominee3.$invalid" class="mt-1 ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z"
                      fill="#34A853" />
                  </svg>
                </div>
                <v-card v-if="activetab == 'tab3' && additionalNominees.length === 0" color="transparent"
                  @click="clearTabr()" class="mt-1 ml-2 elevation-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.3333 5.99984L7.33333 9.99984M7.33333 5.99984L11.3333 9.99984M1.81333 8.63984L4.69333 12.4798C4.928 12.7927 5.04533 12.9492 5.19403 13.062C5.32574 13.1619 5.47488 13.2365 5.63385 13.2819C5.81334 13.3332 6.00889 13.3332 6.4 13.3332H11.4667C12.5868 13.3332 13.1468 13.3332 13.5746 13.1152C13.951 12.9234 14.2569 12.6175 14.4487 12.2412C14.6667 11.8133 14.6667 11.2533 14.6667 10.1332V5.8665C14.6667 4.7464 14.6667 4.18635 14.4487 3.75852C14.2569 3.3822 13.951 3.07624 13.5746 2.88449C13.1468 2.6665 12.5868 2.6665 11.4667 2.6665H6.4C6.00889 2.6665 5.81334 2.6665 5.63385 2.71776C5.47488 2.76317 5.32574 2.83774 5.19403 2.93767C5.04533 3.05051 4.928 3.20695 4.69333 3.51984L1.81333 7.35984C1.6412 7.58934 1.55514 7.7041 1.52196 7.83013C1.49268 7.94137 1.49268 8.0583 1.52196 8.16955C1.55514 8.29558 1.6412 8.41033 1.81333 8.63984Z"
                      :stroke="panel == 2 ? '#fff' : '#666666'" stroke-width="1.6" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </v-card>
              </v-chip>

              <!-- Dynamic nominees 4-10 -->
              <v-chip v-for="(nominee, index) in additionalNominees" :key="'nominee-' + (index + 4)"
                @click="panel = index + 3" :color="panel == index + 3 ? '#000' : '#666666'"
                :text-color="panel == index + 3 ? '#fff' : '#666666'" :outlined="panel != index + 3">
                {{ getOrdinal(index + 4) }} nominee
                <div v-if="isNomineeValid(index)" class="mt-1 ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z"
                      fill="#34A853" />
                  </svg>
                </div>
                <v-card v-if="index === additionalNominees.length - 1" color="transparent"
                  @click.stop="removeNominee(index)" class="mt-1 ml-2 elevation-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.3333 5.99984L7.33333 9.99984M7.33333 5.99984L11.3333 9.99984M1.81333 8.63984L4.69333 12.4798C4.928 12.7927 5.04533 12.9492 5.19403 13.062C5.32574 13.1619 5.47488 13.2365 5.63385 13.2819C5.81334 13.3332 6.00889 13.3332 6.4 13.3332H11.4667C12.5868 13.3332 13.1468 13.3332 13.5746 13.1152C13.951 12.9234 14.2569 12.6175 14.4487 12.2412C14.6667 11.8133 14.6667 11.2533 14.6667 10.1332V5.8665C14.6667 4.7464 14.6667 4.18635 14.4487 3.75852C14.2569 3.3822 13.951 3.07624 13.5746 2.88449C13.1468 2.6665 12.5868 2.6665 11.4667 2.6665H6.4C6.00889 2.6665 5.81334 2.6665 5.63385 2.71776C5.47488 2.76317 5.32574 2.83774 5.19403 2.93767C5.04533 3.05051 4.928 3.20695 4.69333 3.51984L1.81333 7.35984C1.6412 7.58934 1.55514 7.7041 1.52196 7.83013C1.49268 7.94137 1.49268 8.0583 1.52196 8.16955C1.55514 8.29558 1.6412 8.41033 1.81333 8.63984Z"
                      :stroke="panel == index + 3 ? '#fff' : '#666666'" stroke-width="1.6" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </v-card>
              </v-chip>

            </v-chip-group>

            <div v-if="panel == 0" class="pt-2 mb-16 mb-md-0">
              <v-row no-glutters>
                <v-col class="py-0 pr-md-0" cols="12" md="10">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Full Name <span class="red--text">*</span></p>
                  <v-text-field v-on:keypress="isLetter($event)" class="nom mb-3" v-model="nominee1.n1_name"
                    :error-messages="n1_nameErrors" required @blur="$v.nominee1.n1_name.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M14.1333 12.6438C14.1335 12.4937 14.0975 12.3457 14.0282 12.2125C13.959 12.0792 13.8587 11.9647 13.7357 11.8785C12.052 10.7881 10.0709 10.248 8.06667 10.3329C6.06245 10.248 4.08138 10.7881 2.3976 11.8785C2.27466 11.9647 2.17432 12.0792 2.1051 12.2125C2.03588 12.3457 1.99983 12.4937 2 12.6438V14.9996H14.1333V12.6438Z"
                          stroke="#212121" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M8.06647 7.53333C9.8706 7.53333 11.3331 6.0708 11.3331 4.26667C11.3331 2.46254 9.8706 1 8.06647 1C6.26234 1 4.7998 2.46254 4.7998 4.26667C4.7998 6.0708 6.26234 7.53333 8.06647 7.53333Z"
                          stroke="#212121" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </template>

                    <template #append>
                      <!--  -->
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0 pl-md-0" cols="12" md="2">
                  <p class="font-weight-medium fs-17 mb-0">Percentage <span class="red--text">*</span></p>
                  <v-text-field :readonly="activetab == ''" type="number" suffix="%" @change="nomPerChgo()"
                    @keyup="nomPerChgo()" :max="n1_permax" :min="n1_permin" hide-spin-buttons class="nom mb-3"
                    v-model="nominee1.n1_percent" :error-messages="n1_percentErrors" required
                    v-on:keypress="isDigit($event)"
                    @blur="$v.nominee1.n1_percent.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Date of  birth <span class="red--text">*</span></p>

                  <v-menu ref="n1_menu" v-model="n1_menu" :close-on-content-click="false" max-width="280px"
                    min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="n1_dobErrors" required
                        @blur="$v.nominee1.n1_dob.$touch()" class="nom mb-3"
                        :value="nominee1.n1_dob ? formatDate(nominee1.n1_dob) : ''" single-line>
                        <template #prepend-inner>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M10.5287 0.667969C10.8047 0.667969 11.0287 0.891969 11.0287 1.16797L11.029 1.73318C12.0024 1.79991 12.8108 2.13333 13.383 2.7067C14.0077 3.33404 14.3363 4.23604 14.333 5.31804V11.4C14.333 13.6214 12.9223 15.0014 10.6523 15.0014H5.01367C2.74367 15.0014 1.33301 13.602 1.33301 11.3494V5.3167C1.33301 3.2215 2.59104 1.8766 4.6428 1.7334L4.64321 1.16797C4.64321 0.891969 4.86721 0.667969 5.14321 0.667969C5.41921 0.667969 5.64321 0.891969 5.64321 1.16797L5.64301 1.72064H10.0283L10.0287 1.16797C10.0287 0.891969 10.2527 0.667969 10.5287 0.667969ZM13.333 6.60397H2.33301V11.3494C2.33301 13.06 3.28501 14.0014 5.01367 14.0014H10.6523C12.381 14.0014 13.333 13.0774 13.333 11.4L13.333 6.60397ZM10.8005 10.7988C11.0765 10.7988 11.3005 11.0228 11.3005 11.2988C11.3005 11.5748 11.0765 11.7988 10.8005 11.7988C10.5245 11.7988 10.2978 11.5748 10.2978 11.2988C10.2978 11.0228 10.5185 10.7988 10.7945 10.7988H10.8005ZM7.84214 10.7988C8.11814 10.7988 8.34214 11.0228 8.34214 11.2988C8.34214 11.5748 8.11814 11.7988 7.84214 11.7988C7.56614 11.7988 7.33947 11.5748 7.33947 11.2988C7.33947 11.0228 7.56014 10.7988 7.83614 10.7988H7.84214ZM4.87761 10.7988C5.15361 10.7988 5.37761 11.0228 5.37761 11.2988C5.37761 11.5748 5.15361 11.7988 4.87761 11.7988C4.60161 11.7988 4.37427 11.5748 4.37427 11.2988C4.37427 11.0228 4.59561 10.7988 4.87161 10.7988H4.87761ZM10.8005 8.2077C11.0765 8.2077 11.3005 8.4317 11.3005 8.7077C11.3005 8.9837 11.0765 9.2077 10.8005 9.2077C10.5245 9.2077 10.2978 8.9837 10.2978 8.7077C10.2978 8.4317 10.5185 8.2077 10.7945 8.2077H10.8005ZM7.84214 8.2077C8.11814 8.2077 8.34214 8.4317 8.34214 8.7077C8.34214 8.9837 8.11814 9.2077 7.84214 9.2077C7.56614 9.2077 7.33947 8.9837 7.33947 8.7077C7.33947 8.4317 7.56014 8.2077 7.83614 8.2077H7.84214ZM4.87761 8.2077C5.15361 8.2077 5.37761 8.4317 5.37761 8.7077C5.37761 8.9837 5.15361 9.2077 4.87761 9.2077C4.60161 9.2077 4.37427 8.9837 4.37427 8.7077C4.37427 8.4317 4.59561 8.2077 4.87161 8.2077H4.87761ZM10.0283 2.72064H5.64301L5.64321 3.36197C5.64321 3.63797 5.41921 3.86197 5.14321 3.86197C4.86721 3.86197 4.64321 3.63797 4.64321 3.36197L4.64285 2.73577C3.14937 2.86123 2.33301 3.76654 2.33301 5.3167V5.60397H13.333L13.333 5.3167C13.3357 4.49337 13.1143 3.85337 12.675 3.41337C12.2894 3.02657 11.7256 2.79557 11.0292 2.73609L11.0287 3.36197C11.0287 3.63797 10.8047 3.86197 10.5287 3.86197C10.2527 3.86197 10.0287 3.63797 10.0287 3.36197L10.0283 2.72064Z"
                              fill="#121212" />
                          </svg>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee1.n1_dob" @input="n1save()"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                      min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                  <v-select item-disabled="disabled" :items="relationitems1" append-icon="mdi-chevron-down"
                    class="nom mb-3" v-model="nominee1.n1_relation" :error-messages="n1_relationErrors" required
                    @blur="$v.nominee1.n1_relation.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                      </svg>
                    </template>
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs">
                        <div class="d-flex justify-space-between align-center" style="width: 100%">
                          <span>{{ item.text }}</span>
                          <v-chip x-small color="#FCF3F3" class="pa-1" v-if="item.disabled == true">
                            <span style="color: #ff1717; font-size: 10px">
                              You have selected 'Single' as your marital status.
                            </span>
                          </v-chip>
                        </div>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Mobile No <span class="red--text">*</span></p>
                  <v-text-field required type="tel" v-model="nominee1.n1_mobile"
                    :error-messages="n1_mobileerror" oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10)"
                    @input="$v.nominee1.n1_mobile.$touch()" @blur="$v.nominee1.n1_mobile.$touch()" maxlength="10" counter="10" class="txt-field">
                    <template #prepend-inner>
                      <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M11.6667 0.333008H4.33333C3.89147 0.333537 3.46785 0.509302 3.15541 0.821748C2.84296 1.13419 2.6672 1.55781 2.66667 1.99967V13.9997C2.6672 14.4415 2.84296 14.8652 3.15541 15.1776C3.46785 15.49 3.89147 15.6658 4.33333 15.6663H11.6667C12.1085 15.6658 12.5321 15.49 12.8446 15.1776C13.157 14.8652 13.3328 14.4415 13.3333 13.9997V1.99967C13.3328 1.55781 13.157 1.13419 12.8446 0.821748C12.5321 0.509302 12.1085 0.333537 11.6667 0.333008ZM12.6667 12.9997C12.6667 13.0881 12.6315 13.1729 12.569 13.2354C12.5065 13.2979 12.4217 13.333 12.3333 13.333H3.66667C3.57826 13.333 3.49348 13.2979 3.43097 13.2354C3.36845 13.1729 3.33333 13.0881 3.33333 12.9997V1.99967C3.33333 1.91127 3.36845 1.82648 3.43097 1.76397C3.49348 1.70146 3.57826 1.66634 3.66667 1.66634H12.3333C12.4217 1.66634 12.5065 1.70146 12.569 1.76397C12.6315 1.82648 12.6667 1.91127 12.6667 1.99967V12.9997Z"
                            fill="#121212" />
                          <path
                            d="M9.66666 4H6.33333C6.24492 4 6.16014 3.94732 6.09763 3.85355C6.03511 3.75979 6 3.63261 6 3.5C6 3.36739 6.03511 3.24021 6.09763 3.14645C6.16014 3.05268 6.24492 3 6.33333 3H9.66666C9.75507 3 9.83985 3.05268 9.90237 3.14645C9.96488 3.24021 10 3.36739 10 3.5C10 3.63261 9.96488 3.75979 9.90237 3.85355C9.83985 3.94732 9.75507 4 9.66666 4Z"
                            fill="#121212" />
                        </svg>
                      </div>
                    </template>

                  </v-text-field>

                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">
                    Nominee email address <span class="red--text">*</span>

                  </p>

                  <v-text-field v-model="nominee1.n1_email" required :error-messages="n1_emailerror"
                    @blur="$v.nominee1.n1_email.$touch()" type="email" placeholder="Enter email address"
                    class="txt-field">
                    <template #prepend-inner>
                      <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                            stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                          <path
                            d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                            stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                        </svg>
                      </div>
                    </template>

                  </v-text-field>
                </v-col>

                <v-col class="py-0 mt-4" cols="12" md="6">
                  <p class="font-weight-medium fs-17 ">
                    Nominee's identity proof <span class="red--text">*</span>

                  </p>

                  <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee1.n1_proofType"
                    append-icon="mdi-chevron-down" class="nom mb-3" :error-messages="n1_idproofErrors" required
                    @change="clearProofValue('nominee1', 'n1_pan')" @blur="$v.nominee1.n1_proofType.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                      </svg>
                    </template>

                  </v-select>
                </v-col>

                <v-col class="py-0 mt-4" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">
                    Nominee {{ viewnomineeprofftype(nominee1.n1_proofType) }} <span class="red--text">*</span>

                    <v-text-field v-model.trim="nominee1.n1_pan" required :error-messages="n1_proofErrors"
                      v-on:keypress="proofKeypress($event, nominee1.n1_proofType)"
                      :maxlength="nominee1.n1_proofType === 'PAN' ? 10 : nominee1.n1_proofType === 'AADHAR' ? 4 : nominee1.n1_proofType === 'PASSPORT' ? 8 : 15"
                      @input="proofInputFilter(nominee1.n1_pan, nominee1.n1_proofType, 'nominee1', 'n1_pan'); $v.nominee1.n1_pan.$touch()"
                      @blur="$v.nominee1.n1_pan.$touch()" class="txt-field">
                      <template #prepend-inner>
                        <div class="mr-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                              d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                              stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                            <path
                              d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                              stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                          </svg>
                        </div>
                      </template>

                    </v-text-field>
                  </p>


                </v-col>



                <v-col v-if="activetab == ''" cols="12" order="last" class="py-0 mt-2 mb-2">
                  <p class="font-weight-medium fs-17 mb-1">I want the following nomination details to be printed in the account / holding statements <span class="red--text">*</span></p>
                  <v-checkbox :input-value="holdPrint === 'nom_name'" @change="onHoldPrintCheck('nom_name', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                    <template #label><span class="subtitle-2 black--text font-weight-medium">Name of the Nominee(s)</span></template>
                  </v-checkbox>
                  <v-checkbox :input-value="holdPrint === 'nom_status'" @change="onHoldPrintCheck('nom_status', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                    <template #label><span class="subtitle-2 black--text font-weight-medium">Whether nomination given: Yes / No <span class="txt-666 font-weight-regular">(not name of the nominee)</span></span></template>
                  </v-checkbox>
                  <p v-if="holdPrintErrors.length" class="red--text caption mb-0 mt-1">{{ holdPrintErrors[0] }}</p>
                </v-col>

                <v-col cols="12" class="py-0" v-if="nominee1.n1_age">
                  <p class="txt-666 font-weight-medium mb-2">The nominee is under the age of 18, so guardian details are mandatory.</p>
                </v-col>
                <v-col class="py-0" cols="12" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian Full Name <span class="red--text">*</span></p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')"
                    class="nom mb-3" v-model="nominee1.g1_name" :error-messages="g1_nameErrors"
                    @input="$v.nominee1.g1_name.$touch()" @blur="$v.nominee1.g1_name.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth <span class="red--text">*</span></p>

                  <v-menu ref="g1_menu" v-model="g1_menu" :close-on-content-click="false" max-width="280px"
                    min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="g1_dobErrors"
                        @blur="$v.nominee1.g1_dob.$touch()" class="nom mb-3"
                        :value="nominee1.g1_dob ? formatDate(nominee1.g1_dob) : ''" single-line
                        hint="Guardian must be over 18 years." persistent-hint> </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee1.g1_dob" @input="g1save()" :max="agevalid"
                      min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                  <v-select :items="guardianrelationitems" append-icon="mdi-chevron-down" class="nom mb-3"
                    v-model="nominee1.g1_relation" :error-messages="g1_relationErrors"
                    @blur="$v.nominee1.g1_relation.$touch()"></v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian's identity proof <span class="red--text">*</span></p>
                  <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee1.g1_proofType"
                    append-icon="mdi-chevron-down" class="nom mb-3" :error-messages="g1_idproofErrors" required
                    @change="clearProofValue('nominee1', 'g1_pan')" @blur="$v.nominee1.g1_proofType.$touch()"></v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian {{ viewnomineeprofftype(nominee1.g1_proofType) }} <span class="red--text">*</span></p>
                  <v-text-field v-model.trim="nominee1.g1_pan" required :error-messages="g1_panErrors" class="nom mb-3"
                    v-on:keypress="proofKeypress($event, nominee1.g1_proofType)"
                    :maxlength="nominee1.g1_proofType === 'PAN' ? 10 : nominee1.g1_proofType === 'AADHAR' ? 4 : nominee1.g1_proofType === 'PASSPORT' ? 8 : 15"
                    @input="proofInputFilter(nominee1.g1_pan, nominee1.g1_proofType, 'nominee1', 'g1_pan'); $v.nominee1.g1_pan.$touch()"
                    @blur="$v.nominee1.g1_pan.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="12" md="10" v-if="nominee1.n1_age && nominee1.g1_relation === 'Court-Appointed Guardian'">
                   <p class="font-weight-medium fs-17 mb-0">Upload Court Order <span class="red--text">*</span></p>
                   <div v-if="typeof nominee1.g1_proof === 'string' && nominee1.g1_proof.length > 0">
                     <div class="mb-3">
                        <iframe :src="nominee1.g1_proof" width="100%" height="400px" style="border: 1px solid #ccc;"></iframe>
                     </div>
                     <div class="d-flex align-center mb-3">
                      <v-btn small outlined color="error" @click="nominee1.g1_proof = null">
                        Change File
                      </v-btn>
                     </div>
                   </div>
                   <v-file-input v-else v-model="nominee1.g1_proof" :error-messages="g1_proofErrors" required outlined dense label="Upload File"
                    prepend-icon="" prepend-inner-icon="mdi-paperclip" class="nom mb-3"
                    accept=".pdf,.jpg,.jpeg,.png"
                    @change="$v.nominee1.g1_proof.$touch()" @blur="$v.nominee1.g1_proof.$touch()">
                   </v-file-input>
                </v-col>


              </v-row>
            </div>
            <div v-if="panel == 1" class="pt-2 mb-16 mb-md-0">
              <v-row no-glutters>
                <v-col class="py-0 pr-md-0" cols="12" md="10">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Full Name <span class="red--text">*</span></p>
                  <v-text-field v-on:keypress="isLetter($event)" class="nom mb-3" v-model="nominee2.n2_name"
                    :error-messages="n2_nameErrors" required @blur="$v.nominee2.n2_name.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M14.1333 12.6438C14.1335 12.4937 14.0975 12.3457 14.0282 12.2125C13.959 12.0792 13.8587 11.9647 13.7357 11.8785C12.052 10.7881 10.0709 10.248 8.06667 10.3329C6.06245 10.248 4.08138 10.7881 2.3976 11.8785C2.27466 11.9647 2.17432 12.0792 2.1051 12.2125C2.03588 12.3457 1.99983 12.4937 2 12.6438V14.9996H14.1333V12.6438Z"
                          stroke="#212121" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M8.06647 7.53333C9.8706 7.53333 11.3331 6.0708 11.3331 4.26667C11.3331 2.46254 9.8706 1 8.06647 1C6.26234 1 4.7998 2.46254 4.7998 4.26667C4.7998 6.0708 6.26234 7.53333 8.06647 7.53333Z"
                          stroke="#212121" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </template>

                    <template #append>
                      <!--  -->
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0 pl-md-0" cols="12" md="2">
                  <p class="font-weight-medium fs-17 mb-0">Percentage <span class="red--text">*</span></p>
                  <v-text-field :readonly="activetab == ''" type="number" suffix="%" @change="nomPerChgt()"
                    @keyup="nomPerChgt()" :max="n2_permax" :min="n2_permin" hide-spin-buttons class="nom mb-3"
                    v-model="nominee2.n2_percent" :error-messages="n2_percentErrors" required
                    v-on:keypress="isDigit($event)"
                    @blur="$v.nominee2.n2_percent.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth <span class="red--text">*</span></p>

                  <v-menu ref="n2_menu" v-model="n2_menu" :close-on-content-click="false" max-width="280px"
                    min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="n2_dobErrors" required
                        @blur="$v.nominee2.n2_dob.$touch()" class="nom mb-3"
                        :value="nominee2.n2_dob ? formatDate(nominee2.n2_dob) : ''" single-line>
                        <template #prepend-inner>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M10.5287 0.667969C10.8047 0.667969 11.0287 0.891969 11.0287 1.16797L11.029 1.73318C12.0024 1.79991 12.8108 2.13333 13.383 2.7067C14.0077 3.33404 14.3363 4.23604 14.333 5.31804V11.4C14.333 13.6214 12.9223 15.0014 10.6523 15.0014H5.01367C2.74367 15.0014 1.33301 13.602 1.33301 11.3494V5.3167C1.33301 3.2215 2.59104 1.8766 4.6428 1.7334L4.64321 1.16797C4.64321 0.891969 4.86721 0.667969 5.14321 0.667969C5.41921 0.667969 5.64321 0.891969 5.64321 1.16797L5.64301 1.72064H10.0283L10.0287 1.16797C10.0287 0.891969 10.2527 0.667969 10.5287 0.667969ZM13.333 6.60397H2.33301V11.3494C2.33301 13.06 3.28501 14.0014 5.01367 14.0014H10.6523C12.381 14.0014 13.333 13.0774 13.333 11.4L13.333 6.60397ZM10.8005 10.7988C11.0765 10.7988 11.3005 11.0228 11.3005 11.2988C11.3005 11.5748 11.0765 11.7988 10.8005 11.7988C10.5245 11.7988 10.2978 11.5748 10.2978 11.2988C10.2978 11.0228 10.5185 10.7988 10.7945 10.7988H10.8005ZM7.84214 10.7988C8.11814 10.7988 8.34214 11.0228 8.34214 11.2988C8.34214 11.5748 8.11814 11.7988 7.84214 11.7988C7.56614 11.7988 7.33947 11.5748 7.33947 11.2988C7.33947 11.0228 7.56014 10.7988 7.83614 10.7988H7.84214ZM4.87761 10.7988C5.15361 10.7988 5.37761 11.0228 5.37761 11.2988C5.37761 11.5748 5.15361 11.7988 4.87761 11.7988C4.60161 11.7988 4.37427 11.5748 4.37427 11.2988C4.37427 11.0228 4.59561 10.7988 4.87161 10.7988H4.87761ZM10.8005 8.2077C11.0765 8.2077 11.3005 8.4317 11.3005 8.7077C11.3005 8.9837 11.0765 9.2077 10.8005 9.2077C10.5245 9.2077 10.2978 8.9837 10.2978 8.7077C10.2978 8.4317 10.5185 8.2077 10.7945 8.2077H10.8005ZM7.84214 8.2077C8.11814 8.2077 8.34214 8.4317 8.34214 8.7077C8.34214 8.9837 8.11814 9.2077 7.84214 9.2077C7.56614 9.2077 7.33947 8.9837 7.33947 8.7077C7.33947 8.4317 7.56014 8.2077 7.83614 8.2077H7.84214ZM4.87761 8.2077C5.15361 8.2077 5.37761 8.4317 5.37761 8.7077C5.37761 8.9837 5.15361 9.2077 4.87761 9.2077C4.60161 9.2077 4.37427 8.9837 4.37427 8.7077C4.37427 8.4317 4.59561 8.2077 4.87161 8.2077H4.87761ZM10.0283 2.72064H5.64301L5.64321 3.36197C5.64321 3.63797 5.41921 3.86197 5.14321 3.86197C4.86721 3.86197 4.64321 3.63797 4.64321 3.36197L4.64285 2.73577C3.14937 2.86123 2.33301 3.76654 2.33301 5.3167V5.60397H13.333L13.333 5.3167C13.3357 4.49337 13.1143 3.85337 12.675 3.41337C12.2894 3.02657 11.7256 2.79557 11.0292 2.73609L11.0287 3.36197C11.0287 3.63797 10.8047 3.86197 10.5287 3.86197C10.2527 3.86197 10.0287 3.63797 10.0287 3.36197L10.0283 2.72064Z"
                              fill="#121212" />
                          </svg>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee2.n2_dob" @input="n2save()"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                      min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                  <v-select item-disabled="disabled" :items="relationitems1" append-icon="mdi-chevron-down"
                    class="nom mb-3" v-model="nominee2.n2_relation" :error-messages="n2_relationErrors" required
                    @blur="$v.nominee2.n2_relation.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                      </svg>
                    </template>
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs">
                        <div class="d-flex justify-space-between align-center" style="width: 100%">
                          <span>{{ item.text }}</span>
                          <v-chip x-small color="#FCF3F3" class="pa-1" v-if="item.disabled == true">
                            <span style="color: #ff1717; font-size: 10px">
                              You have selected 'Single' as your marital status.
                            </span>
                          </v-chip>
                        </div>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Mobile No <span class="red--text">*</span></p>
                  <v-text-field required type="tel" v-model="nominee2.n2_mobile"
                    :error-messages="n2_mobileerror" oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10)"
                    @input="$v.nominee2.n2_mobile.$touch()" @blur="$v.nominee2.n2_mobile.$touch()" maxlength="10" counter="10" class="txt-field">
                    <template #prepend-inner>
                      <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M11.6667 0.333008H4.33333C3.89147 0.333537 3.46785 0.509302 3.15541 0.821748C2.84296 1.13419 2.6672 1.55781 2.66667 1.99967V13.9997C2.6672 14.4415 2.84296 14.8652 3.15541 15.1776C3.46785 15.49 3.89147 15.6658 4.33333 15.6663H11.6667C12.1085 15.6658 12.5321 15.49 12.8446 15.1776C13.157 14.8652 13.3328 14.4415 13.3333 13.9997V1.99967C13.3328 1.55781 13.157 1.13419 12.8446 0.821748C12.5321 0.509302 12.1085 0.333537 11.6667 0.333008ZM12.6667 12.9997C12.6667 13.0881 12.6315 13.1729 12.569 13.2354C12.5065 13.2979 12.4217 13.333 12.3333 13.333H3.66667C3.57826 13.333 3.49348 13.2979 3.43097 13.2354C3.36845 13.1729 3.33333 13.0881 3.33333 12.9997V1.99967C3.33333 1.91127 3.36845 1.82648 3.43097 1.76397C3.49348 1.70146 3.57826 1.66634 3.66667 1.66634H12.3333C12.4217 1.66634 12.5065 1.70146 12.569 1.76397C12.6315 1.82648 12.6667 1.91127 12.6667 1.99967V12.9997Z"
                            fill="#121212" />
                          <path
                            d="M9.66666 4H6.33333C6.24492 4 6.16014 3.94732 6.09763 3.85355C6.03511 3.75979 6 3.63261 6 3.5C6 3.36739 6.03511 3.24021 6.09763 3.14645C6.16014 3.05268 6.24492 3 6.33333 3H9.66666C9.75507 3 9.83985 3.05268 9.90237 3.14645C9.96488 3.24021 10 3.36739 10 3.5C10 3.63261 9.96488 3.75979 9.90237 3.85355C9.83985 3.94732 9.75507 4 9.66666 4Z"
                            fill="#121212" />
                        </svg>
                      </div>
                    </template>

                  </v-text-field>

                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">
                    Nominee email address <span class="red--text">*</span>

                  </p>

                  <v-text-field v-model="nominee2.n2_email" required :error-messages="n2_emailerror"
                    @blur="$v.nominee2.n2_email.$touch()" type="email" placeholder="Enter email address"
                    class="txt-field">
                    <template #prepend-inner>
                      <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                            stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                          <path
                            d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                            stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                        </svg>
                      </div>
                    </template>

                  </v-text-field>
                </v-col>

                <v-col class="py-0 mt-4" cols="12" md="6">
                  <p class="font-weight-medium fs-17 ">
                    Nominee's identity proof <span class="red--text">*</span>

                  </p>

                  <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee2.n2_proofType"
                    append-icon="mdi-chevron-down" class="nom mb-3" :error-messages="n2_idproofErrors" required
                    @change="clearProofValue('nominee2', 'n2_pan')" @blur="$v.nominee2.n2_proofType.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                      </svg>
                    </template>

                  </v-select>
                </v-col>

                <v-col class="py-0 mt-4" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">
                    Nominee {{ viewnomineeprofftype(nominee2.n2_proofType) }} <span class="red--text">*</span>

                    <v-text-field v-model.trim="nominee2.n2_pan" required :error-messages="n2_proofErrors"
                      v-on:keypress="proofKeypress($event, nominee2.n2_proofType)"
                      :maxlength="nominee2.n2_proofType === 'PAN' ? 10 : nominee2.n2_proofType === 'AADHAR' ? 4 : nominee2.n2_proofType === 'PASSPORT' ? 8 : 15"
                      @input="proofInputFilter(nominee2.n2_pan, nominee2.n2_proofType, 'nominee2', 'n2_pan'); $v.nominee2.n2_pan.$touch()"
                      @blur="$v.nominee2.n2_pan.$touch()" class="txt-field">
                      <template #prepend-inner>
                        <div class="mr-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                              d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                              stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                            <path
                              d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                              stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                          </svg>
                        </div>
                      </template>

                    </v-text-field>
                  </p>


                </v-col>


                <v-col v-if="activetab == 'tab2'" cols="12" order="last" class="py-0 mt-2 mb-2">
                  <p class="font-weight-medium fs-17 mb-1">I want the following nomination details to be printed in the account / holding statements <span class="red--text">*</span></p>
                  <v-checkbox :input-value="holdPrint === 'nom_name'" @change="onHoldPrintCheck('nom_name', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                    <template #label><span class="subtitle-2 black--text font-weight-medium">Name of the Nominee(s)</span></template>
                  </v-checkbox>
                  <v-checkbox :input-value="holdPrint === 'nom_status'" @change="onHoldPrintCheck('nom_status', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                    <template #label><span class="subtitle-2 black--text font-weight-medium">Whether nomination given: Yes / No <span class="txt-666 font-weight-regular">(not name of the nominee)</span></span></template>
                  </v-checkbox>
                  <p v-if="holdPrintErrors.length" class="red--text caption mb-0 mt-1">{{ holdPrintErrors[0] }}</p>
                </v-col>

                <v-col cols="12" class="py-0" v-if="nominee2.n2_age">
                  <p class="txt-666 font-weight-medium mb-2">The nominee is under the age of 18, so guardian details are mandatory.</p>
                </v-col>
                <v-col class="py-0" cols="12" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian Full Name <span class="red--text">*</span></p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')"
                    class="nom mb-3" v-model="nominee2.g2_name" :error-messages="g2_nameErrors"
                    @input="$v.nominee2.g2_name.$touch()" @blur="$v.nominee2.g2_name.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth <span class="red--text">*</span></p>

                  <v-menu ref="g2_menu" v-model="g2_menu" :close-on-content-click="false" max-width="280px"
                    min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="g2_dobErrors"
                        @blur="$v.nominee2.g2_dob.$touch()" class="nom mb-3"
                        :value="nominee2.g2_dob ? formatDate(nominee2.g2_dob) : ''" single-line
                        hint="Guardian must be over 18 years." persistent-hint> </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee2.g2_dob" @input="g2save()" :max="agevalid"
                      min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="12" md="6" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                  <v-select :items="guardianrelationitems" append-icon="mdi-chevron-down" class="nom mb-3"
                    v-model="nominee2.g2_relation" :error-messages="g2_relationErrors"
                    @blur="$v.nominee2.g2_relation.$touch()"></v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian's identity proof <span class="red--text">*</span></p>
                  <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee2.g2_proofType"
                    append-icon="mdi-chevron-down" class="nom mb-3" :error-messages="g2_idproofErrors" required
                    @change="clearProofValue('nominee2', 'g2_pan')" @blur="$v.nominee2.g2_proofType.$touch()"></v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian {{ viewnomineeprofftype(nominee2.g2_proofType) }} <span class="red--text">*</span></p>
                  <v-text-field v-model.trim="nominee2.g2_pan" required :error-messages="g2_panErrors" class="nom mb-3"
                    v-on:keypress="proofKeypress($event, nominee2.g2_proofType)"
                    :maxlength="nominee2.g2_proofType === 'PAN' ? 10 : nominee2.g2_proofType === 'AADHAR' ? 4 : nominee2.g2_proofType === 'PASSPORT' ? 8 : 15"
                    @input="proofInputFilter(nominee2.g2_pan, nominee2.g2_proofType, 'nominee2', 'g2_pan'); $v.nominee2.g2_pan.$touch()"
                    @blur="$v.nominee2.g2_pan.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="12" md="10" v-if="nominee2.n2_age && nominee2.g2_relation === 'Court-Appointed Guardian'">
                   <p class="font-weight-medium fs-17 mb-0">Upload Court Order <span class="red--text">*</span></p>
                   <div v-if="typeof nominee2.g2_proof === 'string' && nominee2.g2_proof.length > 0">
                     <div class="mb-3">
                        <iframe :src="nominee2.g2_proof" width="100%" height="400px" style="border: 1px solid #ccc;"></iframe>
                     </div>
                     <div class="d-flex align-center mb-3">
                      <v-btn small outlined color="error" @click="nominee2.g2_proof = null">
                        Change File
                      </v-btn>
                     </div>
                   </div>
                   <v-file-input v-else v-model="nominee2.g2_proof" :error-messages="g2_proofErrors" required outlined dense label="Upload File"
                    prepend-icon="" prepend-inner-icon="mdi-paperclip" class="nom mb-3"
                    accept=".pdf,.jpg,.jpeg,.png"
                    @change="$v.nominee2.g2_proof.$touch()" @blur="$v.nominee2.g2_proof.$touch()">
                   </v-file-input>
                </v-col>

              </v-row>
            </div>
            <div v-if="panel == 2" class="pt-2 mb-16 mb-md-0">
              <v-row no-glutters>
                <v-col class="py-0 pr-md-0" cols="12" md="10">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Full Name <span class="red--text">*</span></p>
                  <v-text-field v-on:keypress="isLetter($event)" class="nom mb-3" v-model="nominee3.n3_name"
                    :error-messages="n3_nameErrors" required @blur="$v.nominee3.n3_name.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M14.1333 12.6438C14.1335 12.4937 14.0975 12.3457 14.0282 12.2125C13.959 12.0792 13.8587 11.9647 13.7357 11.8785C12.052 10.7881 10.0709 10.248 8.06667 10.3329C6.06245 10.248 4.08138 10.7881 2.3976 11.8785C2.27466 11.9647 2.17432 12.0792 2.1051 12.2125C2.03588 12.3457 1.99983 12.4937 2 12.6438V14.9996H14.1333V12.6438Z"
                          stroke="#212121" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M8.06647 7.53333C9.8706 7.53333 11.3331 6.0708 11.3331 4.26667C11.3331 2.46254 9.8706 1 8.06647 1C6.26234 1 4.7998 2.46254 4.7998 4.26667C4.7998 6.0708 6.26234 7.53333 8.06647 7.53333Z"
                          stroke="#212121" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </template>

                    <template #append>
                      <!--  -->
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0 pl-md-0" cols="12" md="2">
                  <p class="font-weight-medium fs-17 mb-0">Percentage <span class="red--text">*</span></p>
                  <v-text-field :readonly="activetab == ''" type="number" suffix="%" @change="nomPerChgr()"
                    @keyup="nomPerChgr()" :max="n3_permax" :min="n3_permin" hide-spin-buttons class="nom mb-3"
                    v-model="nominee3.n3_percent" :error-messages="n3_percentErrors" required
                    v-on:keypress="isDigit($event)"
                    @blur="$v.nominee3.n3_percent.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth <span class="red--text">*</span></p>

                  <v-menu ref="n3_menu" v-model="n3_menu" :close-on-content-click="false" max-width="280px"
                    min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="n3_dobErrors" required
                        @blur="$v.nominee3.n3_dob.$touch()" class="nom mb-3"
                        :value="nominee3.n3_dob ? formatDate(nominee3.n3_dob) : ''" single-line>
                        <template #prepend-inner>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M10.5287 0.667969C10.8047 0.667969 11.0287 0.891969 11.0287 1.16797L11.029 1.73318C12.0024 1.79991 12.8108 2.13333 13.383 2.7067C14.0077 3.33404 14.3363 4.23604 14.333 5.31804V11.4C14.333 13.6214 12.9223 15.0014 10.6523 15.0014H5.01367C2.74367 15.0014 1.33301 13.602 1.33301 11.3494V5.3167C1.33301 3.2215 2.59104 1.8766 4.6428 1.7334L4.64321 1.16797C4.64321 0.891969 4.86721 0.667969 5.14321 0.667969C5.41921 0.667969 5.64321 0.891969 5.64321 1.16797L5.64301 1.72064H10.0283L10.0287 1.16797C10.0287 0.891969 10.2527 0.667969 10.5287 0.667969ZM13.333 6.60397H2.33301V11.3494C2.33301 13.06 3.28501 14.0014 5.01367 14.0014H10.6523C12.381 14.0014 13.333 13.0774 13.333 11.4L13.333 6.60397ZM10.8005 10.7988C11.0765 10.7988 11.3005 11.0228 11.3005 11.2988C11.3005 11.5748 11.0765 11.7988 10.8005 11.7988C10.5245 11.7988 10.2978 11.5748 10.2978 11.2988C10.2978 11.0228 10.5185 10.7988 10.7945 10.7988H10.8005ZM7.84214 10.7988C8.11814 10.7988 8.34214 11.0228 8.34214 11.2988C8.34214 11.5748 8.11814 11.7988 7.84214 11.7988C7.56614 11.7988 7.33947 11.5748 7.33947 11.2988C7.33947 11.0228 7.56014 10.7988 7.83614 10.7988H7.84214ZM4.87761 10.7988C5.15361 10.7988 5.37761 11.0228 5.37761 11.2988C5.37761 11.5748 5.15361 11.7988 4.87761 11.7988C4.60161 11.7988 4.37427 11.5748 4.37427 11.2988C4.37427 11.0228 4.59561 10.7988 4.87161 10.7988H4.87761ZM10.8005 8.2077C11.0765 8.2077 11.3005 8.4317 11.3005 8.7077C11.3005 8.9837 11.0765 9.2077 10.8005 9.2077C10.5245 9.2077 10.2978 8.9837 10.2978 8.7077C10.2978 8.4317 10.5185 8.2077 10.7945 8.2077H10.8005ZM7.84214 8.2077C8.11814 8.2077 8.34214 8.4317 8.34214 8.7077C8.34214 8.9837 8.11814 9.2077 7.84214 9.2077C7.56614 9.2077 7.33947 8.9837 7.33947 8.7077C7.33947 8.4317 7.56014 8.2077 7.83614 8.2077H7.84214ZM4.87761 8.2077C5.15361 8.2077 5.37761 8.4317 5.37761 8.7077C5.37761 8.9837 5.15361 9.2077 4.87761 9.2077C4.60161 9.2077 4.37427 8.9837 4.37427 8.7077C4.37427 8.4317 4.59561 8.2077 4.87161 8.2077H4.87761ZM10.0283 2.72064H5.64301L5.64321 3.36197C5.64321 3.63797 5.41921 3.86197 5.14321 3.86197C4.86721 3.86197 4.64321 3.63797 4.64321 3.36197L4.64285 2.73577C3.14937 2.86123 2.33301 3.76654 2.33301 5.3167V5.60397H13.333L13.333 5.3167C13.3357 4.49337 13.1143 3.85337 12.675 3.41337C12.2894 3.02657 11.7256 2.79557 11.0292 2.73609L11.0287 3.36197C11.0287 3.63797 10.8047 3.86197 10.5287 3.86197C10.2527 3.86197 10.0287 3.63797 10.0287 3.36197L10.0283 2.72064Z"
                              fill="#121212" />
                          </svg>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee3.n3_dob" @input="n3save()"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                      min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                  <v-select item-disabled="disabled" :items="relationitems1" append-icon="mdi-chevron-down"
                    class="nom mb-3" v-model="nominee3.n3_relation" :error-messages="n3_relationErrors" required
                    @blur="$v.nominee3.n3_relation.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                      </svg>
                    </template>
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs">
                        <div class="d-flex justify-space-between align-center" style="width: 100%">
                          <span>{{ item.text }}</span>
                          <v-chip x-small color="#FCF3F3" class="pa-1" v-if="item.disabled == true">
                            <span style="color: #ff1717; font-size: 10px">
                              You have selected 'Single' as your marital status.
                            </span>
                          </v-chip>
                        </div>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Mobile No <span class="red--text">*</span></p>
                  <v-text-field required type="tel" v-model="nominee3.n3_mobile"
                    :error-messages="n3_mobileerror" oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10)"
                    @input="$v.nominee3.n3_mobile.$touch()" @blur="$v.nominee3.n3_mobile.$touch()" maxlength="10" counter="10" class="txt-field">
                    <template #prepend-inner>
                      <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M11.6667 0.333008H4.33333C3.89147 0.333537 3.46785 0.509302 3.15541 0.821748C2.84296 1.13419 2.6672 1.55781 2.66667 1.99967V13.9997C2.6672 14.4415 2.84296 14.8652 3.15541 15.1776C3.46785 15.49 3.89147 15.6658 4.33333 15.6663H11.6667C12.1085 15.6658 12.5321 15.49 12.8446 15.1776C13.157 14.8652 13.3328 14.4415 13.3333 13.9997V1.99967C13.3328 1.55781 13.157 1.13419 12.8446 0.821748C12.5321 0.509302 12.1085 0.333537 11.6667 0.333008ZM12.6667 12.9997C12.6667 13.0881 12.6315 13.1729 12.569 13.2354C12.5065 13.2979 12.4217 13.333 12.3333 13.333H3.66667C3.57826 13.333 3.49348 13.2979 3.43097 13.2354C3.36845 13.1729 3.33333 13.0881 3.33333 12.9997V1.99967C3.33333 1.91127 3.36845 1.82648 3.43097 1.76397C3.49348 1.70146 3.57826 1.66634 3.66667 1.66634H12.3333C12.4217 1.66634 12.5065 1.70146 12.569 1.76397C12.6315 1.82648 12.6667 1.91127 12.6667 1.99967V12.9997Z"
                            fill="#121212" />
                          <path
                            d="M9.66666 4H6.33333C6.24492 4 6.16014 3.94732 6.09763 3.85355C6.03511 3.75979 6 3.63261 6 3.5C6 3.36739 6.03511 3.24021 6.09763 3.14645C6.16014 3.05268 6.24492 3 6.33333 3H9.66666C9.75507 3 9.83985 3.05268 9.90237 3.14645C9.96488 3.24021 10 3.36739 10 3.5C10 3.63261 9.96488 3.75979 9.90237 3.85355C9.83985 3.94732 9.75507 4 9.66666 4Z"
                            fill="#121212" />
                        </svg>
                      </div>
                    </template>

                  </v-text-field>

                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">
                    Nominee email address <span class="red--text">*</span>

                  </p>

                  <v-text-field v-model="nominee3.n3_email" required :error-messages="n3_emailerror"
                    @blur="$v.nominee3.n3_email.$touch()" type="email" placeholder="Enter email address"
                    class="txt-field">
                    <template #prepend-inner>
                      <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                            stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                          <path
                            d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                            stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                        </svg>
                      </div>
                    </template>

                  </v-text-field>
                </v-col>

                <v-col class="py-0 mt-4" cols="12" md="6">
                  <p class="font-weight-medium fs-17 ">
                    Nominee's identity proof <span class="red--text">*</span>

                  </p>

                  <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee3.n3_proofType"
                    append-icon="mdi-chevron-down" class="nom mb-3" :error-messages="n3_idproofErrors" required
                    @change="clearProofValue('nominee3', 'n3_pan')" @blur="$v.nominee3.n3_proofType.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                      </svg>
                    </template>

                  </v-select>
                </v-col>

                <v-col class="py-0 mt-4" cols="12" md="6">
                  <p class="font-weight-medium fs-17 mb-0">
                    Nominee {{ viewnomineeprofftype(nominee3.n3_proofType) }} <span class="red--text">*</span>

                    <v-text-field v-model.trim="nominee3.n3_pan" required :error-messages="n3_proofErrors"
                      v-on:keypress="proofKeypress($event, nominee3.n3_proofType)"
                      :maxlength="nominee3.n3_proofType === 'PAN' ? 10 : nominee3.n3_proofType === 'AADHAR' ? 4 : nominee3.n3_proofType === 'PASSPORT' ? 8 : 15"
                      @input="proofInputFilter(nominee3.n3_pan, nominee3.n3_proofType, 'nominee3', 'n3_pan'); $v.nominee3.n3_pan.$touch()"
                      @blur="$v.nominee3.n3_pan.$touch()" class="txt-field">
                      <template #prepend-inner>
                        <div class="mr-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                              d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                              stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                            <path
                              d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                              stroke="#666666" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="square" />
                          </svg>
                        </div>
                      </template>

                    </v-text-field>
                  </p>


                </v-col>


                <v-col v-if="activetab == 'tab3' && additionalNominees.length === 0" cols="12" order="last" class="py-0 mt-2 mb-2">
                  <p class="font-weight-medium fs-17 mb-1">I want the following nomination details to be printed in the account / holding statements <span class="red--text">*</span></p>
                  <v-checkbox :input-value="holdPrint === 'nom_name'" @change="onHoldPrintCheck('nom_name', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                    <template #label><span class="subtitle-2 black--text font-weight-medium">Name of the Nominee(s)</span></template>
                  </v-checkbox>
                  <v-checkbox :input-value="holdPrint === 'nom_status'" @change="onHoldPrintCheck('nom_status', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                    <template #label><span class="subtitle-2 black--text font-weight-medium">Whether nomination given: Yes / No <span class="txt-666 font-weight-regular">(not name of the nominee)</span></span></template>
                  </v-checkbox>
                  <p v-if="holdPrintErrors.length" class="red--text caption mb-0 mt-1">{{ holdPrintErrors[0] }}</p>
                </v-col>

                <v-col cols="12" class="py-0" v-if="nominee3.n3_age">
                  <p class="txt-666 font-weight-medium mb-2">The nominee is under the age of 18, so guardian details are mandatory.</p>
                </v-col>
                <v-col class="py-0" cols="12" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian Full Name <span class="red--text">*</span></p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')"
                    class="nom mb-3" v-model="nominee3.g3_name" :error-messages="g3_nameErrors"
                    @input="$v.nominee3.g3_name.$touch()" @blur="$v.nominee3.g3_name.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth <span class="red--text">*</span></p>
                  <v-menu ref="g3_menu" v-model="g3_menu" :close-on-content-click="false" max-width="280px"
                    min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="g3_dobErrors"
                        @blur="$v.nominee3.g3_dob.$touch()" class="nom mb-3"
                        :value="nominee3.g3_dob ? formatDate(nominee3.g3_dob) : ''" single-line
                        hint="Guardian must be over 18 years." persistent-hint> </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee3.g3_dob" @input="g3save()" :max="agevalid"
                      min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                  <v-select :items="guardianrelationitems" append-icon="mdi-chevron-down" class="nom mb-3"
                    v-model="nominee3.g3_relation" :error-messages="g3_relationErrors"
                    @blur="$v.nominee3.g3_relation.$touch()"></v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian's identity proof <span class="red--text">*</span></p>
                  <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee3.g3_proofType"
                    append-icon="mdi-chevron-down" class="nom mb-3" :error-messages="g3_idproofErrors" required
                    @change="clearProofValue('nominee3', 'g3_pan')" @blur="$v.nominee3.g3_proofType.$touch()"></v-select>
                </v-col>

                <v-col class="py-0" cols="12" md="6" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian {{ viewnomineeprofftype(nominee3.g3_proofType) }} <span class="red--text">*</span></p>
                  <v-text-field v-model.trim="nominee3.g3_pan" required :error-messages="g3_panErrors" class="nom mb-3"
                    v-on:keypress="proofKeypress($event, nominee3.g3_proofType)"
                    :maxlength="nominee3.g3_proofType === 'PAN' ? 10 : nominee3.g3_proofType === 'AADHAR' ? 4 : nominee3.g3_proofType === 'PASSPORT' ? 8 : 15"
                    @input="proofInputFilter(nominee3.g3_pan, nominee3.g3_proofType, 'nominee3', 'g3_pan'); $v.nominee3.g3_pan.$touch()"
                    @blur="$v.nominee3.g3_pan.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="12" v-if="nominee3.n3_age && nominee3.g3_relation === 'Court-Appointed Guardian'">
                   <p class="font-weight-medium fs-17 mb-0">Upload Court Order <span class="red--text">*</span></p>
                   <div v-if="typeof nominee3.g3_proof === 'string' && nominee3.g3_proof.length > 0">
                     <div class="mb-3">
                        <iframe :src="nominee3.g3_proof" width="100%" height="400px" style="border: 1px solid #ccc;"></iframe>
                     </div>
                     <div class="d-flex align-center mb-3">
                      <v-btn small outlined color="error" @click="nominee3.g3_proof = null">
                        Change File
                      </v-btn>
                     </div>
                   </div>
                   <v-file-input v-else v-model="nominee3.g3_proof" :error-messages="g3_proofErrors" required outlined dense label="Upload File"
                    prepend-icon="" prepend-inner-icon="mdi-paperclip" class="nom mb-3"
                    accept=".pdf,.jpg,.jpeg,.png"
                    @change="$v.nominee3.g3_proof.$touch()" @blur="$v.nominee3.g3_proof.$touch()">
                   </v-file-input>
                </v-col>

              </v-row>
            </div>

            <!-- Dynamic Nominee Forms (4-10) -->
            <template v-for="(nominee, index) in additionalNominees">
              <div :key="'form-' + (index + 4)" v-if="panel == index + 3" class="pt-2">
                <v-row>
                  <v-col class="py-0 pr-md-0" cols="12" md="10">
                    <p class="font-weight-medium fs-17 mb-0">Nominee Full Name <span class="red--text">*</span></p>
                    <v-text-field v-on:keypress="isLetter($event)" class="nom mb-3" v-model="nominee.name"
                      :error-messages="getDynamicError(index, 'name')" required
                      @blur="touchDynamicField(index, 'name')">
                    </v-text-field>
                  </v-col>
                  <v-col class="py-0 pl-md-0" cols="12" md="2">
                    <p class="font-weight-medium fs-17 mb-0">Percentage <span class="red--text">*</span></p>
                    <v-text-field type="number" suffix="%" :max="100" :min="0" hide-spin-buttons class="nom ml-5 mb-3"
                      v-model="nominee.percent" :error-messages="getDynamicError(index, 'percent')" required
                      v-on:keypress="isDigit($event)"
                      @input="dynamicPerChange()" @blur="touchDynamicField(index, 'percent')"></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <p class="font-weight-medium fs-17 mb-0">Date of birth <span class="red--text">*</span></p>
                    <v-menu :ref="'menu_dob_' + index" v-model="nominee.menu_dob" :close-on-content-click="false"
                      max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="getDynamicError(index, 'dob')"
                          required @blur="touchDynamicField(index, 'dob')" class="nom mb-3"
                          :value="nominee.dob ? formatDate(nominee.dob) : ''" single-line>
                        </v-text-field>
                      </template>
                      <v-date-picker no-title class="nom" v-model="nominee.dob" @input="saveDynamicDob(index)"
                        :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                        min="1940-01-01"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                    <v-select item-disabled="disabled" :items="relationitems1" append-icon="mdi-chevron-down"
                      class="nom mb-3" v-model="nominee.relation" :error-messages="getDynamicError(index, 'relation')"
                      required @blur="touchDynamicField(index, 'relation')">
                    </v-select>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <p class="font-weight-medium fs-17 mb-0">Nominee Mobile No <span class="red--text">*</span></p>
                    <v-text-field required type="number" hide-spin-buttons v-model="nominee.mobile"
                      :error-messages="getDynamicError(index, 'mobile')"
                      oninput="this.value = this.value.replace('  ', '')" @blur="touchDynamicField(index, 'mobile')"
                      counter="10" class="txt-field">
                    </v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <p class="font-weight-medium fs-17 mb-0">Nominee email address <span class="red--text">*</span></p>
                    <v-text-field v-model="nominee.email" required :error-messages="getDynamicError(index, 'email')"
                      @blur="touchDynamicField(index, 'email')" type="email" placeholder="Enter email address"
                      class="txt-field">
                    </v-text-field>
                  </v-col>
                  <v-col class="py-0 mt-4" cols="12" md="6">
                    <p class="font-weight-medium fs-17 ">Nominee's identity proof <span class="red--text">*</span></p>
                    <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee.proofType"
                      append-icon="mdi-chevron-down" class="nom mb-3"
                      :error-messages="getDynamicError(index, 'proofType')" required
                      @change="clearDynamicProofValue(index)"
                      @blur="touchDynamicField(index, 'proofType')">
                    </v-select>
                  </v-col>
                  <v-col class="py-0 mt-4" cols="12" md="6">
                    <p class="font-weight-medium fs-17 mb-0">Nominee {{ viewnomineeprofftype(nominee.proofType) }} <span class="red--text">*</span></p>
                    <v-text-field v-model.trim="nominee.proof" required :error-messages="getDynamicError(index, 'proof')"
                      v-on:keypress="proofKeypress($event, nominee.proofType)"
                      :maxlength="nominee.proofType === 'PAN' ? 10 : nominee.proofType === 'AADHAR' ? 4 : nominee.proofType === 'PASSPORT' ? 8 : 15"
                      @input="dynamicProofInputFilter(index, nominee.proofType); touchDynamicField(index, 'proof')"
                      @blur="touchDynamicField(index, 'proof')" class="txt-field">
                    </v-text-field>
                  </v-col>


                  <v-col v-if="index === additionalNominees.length - 1" cols="12" order="last" class="py-0 mt-2 mb-2">
                    <p class="font-weight-medium fs-17 mb-1">I want the following nomination details to be printed in the account / holding statements <span class="red--text">*</span></p>
                    <v-checkbox :input-value="holdPrint === 'nom_name'" @change="onHoldPrintCheck('nom_name', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                      <template #label><span class="subtitle-2 black--text font-weight-medium">Name of the Nominee(s)</span></template>
                    </v-checkbox>
                    <v-checkbox :input-value="holdPrint === 'nom_status'" @change="onHoldPrintCheck('nom_status', $event)" color="#000" hide-details class="ma-0 py-2 pl-2">
                      <template #label><span class="subtitle-2 black--text font-weight-medium">Whether nomination given: Yes / No <span class="txt-666 font-weight-regular">(not name of the nominee)</span></span></template>
                    </v-checkbox>
                    <p v-if="holdPrintErrors.length" class="red--text caption mb-0 mt-1">{{ holdPrintErrors[0] }}</p>
                  </v-col>

                  <v-col cols="12" class="py-0" v-if="nominee.age">
                    <p class="txt-666 font-weight-medium mb-2">The nominee is under the age of 18, so guardian details are mandatory.</p>
                  </v-col>
                  <v-col class="py-0" cols="12" v-if="nominee.age">
                    <p class="font-weight-medium fs-17 mb-0">Guardian Full Name <span class="red--text">*</span></p>
                    <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')"
                      class="nom mb-3" v-model="nominee.g_name" :error-messages="getDynamicError(index, 'g_name')"
                      @blur="touchDynamicField(index, 'g_name')"></v-text-field>
                  </v-col>

                  <v-col class="py-0" cols="12" md="6" v-if="nominee.age">
                    <p class="font-weight-medium fs-17 mb-0">Date of birth <span class="red--text">*</span></p>

                    <v-menu :ref="'menu_g_dob_' + index" v-model="nominee.menu_g_dob" :close-on-content-click="false"
                      max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-bind="attrs" v-on="on" readonly
                          :error-messages="getDynamicError(index, 'g_dob')" @blur="touchDynamicField(index, 'g_dob')"
                          class="nom mb-3" :value="nominee.g_dob ? formatDate(nominee.g_dob) : ''" single-line
                          hint="Guardian must be over 18 years." persistent-hint> </v-text-field>
                      </template>
                      <v-date-picker no-title class="nom" v-model="nominee.g_dob" @input="saveDynamicGDob(index)"
                        :max="agevalid" min="1940-01-01"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6" v-if="nominee.age">
                    <p class="font-weight-medium fs-17 mb-0">Relationship <span class="red--text">*</span></p>
                    <v-select :items="guardianrelationitems" append-icon="mdi-chevron-down" class="nom mb-3"
                      v-model="nominee.g_relation" :error-messages="getDynamicError(index, 'g_relation')"
                      @blur="touchDynamicField(index, 'g_relation')"></v-select>
                  </v-col>

                  <v-col class="py-0" cols="12" md="6" v-if="nominee.age">
                    <p class="font-weight-medium fs-17 mb-0">Guardian's identity proof <span class="red--text">*</span></p>
                    <v-select :items="proffitems" item-text="value" item-value="type" v-model="nominee.g_proofType"
                      append-icon="mdi-chevron-down" class="nom mb-3" :error-messages="getDynamicError(index, 'g_proofType')" required
                      @change="clearDynamicGProofValue(index)" @blur="touchDynamicField(index, 'g_proofType')"></v-select>
                  </v-col>

                  <v-col class="py-0" cols="12" md="6" v-if="nominee.age">
                    <p class="font-weight-medium fs-17 mb-0">Guardian {{ viewnomineeprofftype(nominee.g_proofType) }} <span class="red--text">*</span></p>
                    <v-text-field v-model.trim="nominee.g_pan" required :error-messages="getDynamicError(index, 'g_pan')" class="nom mb-3"
                      v-on:keypress="proofKeypress($event, nominee.g_proofType)"
                      :maxlength="nominee.g_proofType === 'PAN' ? 10 : nominee.g_proofType === 'AADHAR' ? 4 : nominee.g_proofType === 'PASSPORT' ? 8 : 15"
                      @input="dynamicGProofInputFilter(index); touchDynamicField(index, 'g_pan')"
                      @blur="touchDynamicField(index, 'g_pan')"></v-text-field>
                  </v-col>

                  <v-col class="py-0" cols="12" v-if="nominee.age && nominee.g_relation === 'Court-Appointed Guardian'">
                     <p class="font-weight-medium fs-17 mb-0">Upload Court Order <span class="red--text">*</span></p>
                     <div v-if="typeof nominee.g_proof === 'string' && nominee.g_proof.length > 0">
                     <div class="mb-3">
                        <iframe :src="nominee.g_proof" width="100%" height="400px" style="border: 1px solid #ccc;"></iframe>
                     </div>
                     <div class="d-flex align-center mb-3">
                      <v-btn small outlined color="error" @click="nominee.g_proof = null">
                        Change File
                      </v-btn>
                     </div>
                   </div>
                     <v-file-input v-else v-model="nominee.g_proof" :error-messages="getDynamicError(index, 'g_proof')" required outlined dense label="Upload File"
                      prepend-icon="" prepend-inner-icon="mdi-paperclip" class="nom mb-3"
                      accept=".pdf,.jpg,.jpeg,.png"
                      @change="touchDynamicField(index, 'g_proof')" @blur="touchDynamicField(index, 'g_proof')">
                     </v-file-input>
                  </v-col>


                </v-row>
              </div>
            </template>

            <div class="d-none d-md-inline-flex">
              <v-btn v-if="activetab != 'tab2' && activetab != 'tab3'"
                :style="`border: 2px solid ${$v.nominee1.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                outlined height="48px" color="#000" :disabled="$v.nominee1.$invalid || cardloader"
                @click="(activetab = 'tab2'), (nominee1.n1_percent = 50), (nominee2.n2_percent = 50), (panel = 1), (n1_permax = 99), (n2_permax = 99), (nominee2.n2_addrCB = true), (nominee2.g2_addrCB = true), ntAdds(), gtAdds(), distributePercentages()"
                class="text-none rounded-pill elevation-0 mt-6 mr-4"><span class="subtitle-1 font-weight-medium px-6">+
                  Add 2nd
                  Nominee</span></v-btn>

              <v-btn v-if="activetab == 'tab2'"
                :style="`border: 2px solid ${$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                outlined height="48px" color="#000"
                :disabled="$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader"
                @click="(activetab = 'tab3'), (nominee1.n1_percent = 40), (nominee2.n2_percent = 30), (nominee3.n3_percent = 30), (panel = 2), (n1_permax = 98), (n2_permax = 98), (n2_permax = 98), (nominee3.n3_addrCB = true), (nominee3.g3_addrCB = true), nrAdds(), grAdds(), distributePercentages()"
                class="text-none rounded-pill elevation-0 mt-6 mr-4"><span class="subtitle-1 font-weight-medium px-6">+
                  Add 3rd
                  Nominee</span></v-btn>

              <!-- Temporarily commented out - 4th+ nominee (desktop)
              <v-tooltip bottom :disabled="isDynamicNomineesValid && !$v.nominee3.$invalid"
                v-if="activetab == 'tab3' && additionalNominees.length + 3 < 10">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs" class="d-inline-block">
                    <v-btn :disabled="!isDynamicNomineesValid || $v.nominee3.$invalid" outlined height="48px"
                      color="#000" @click="addNominee()" class="text-none rounded-pill elevation-0 mt-6 mr-4"><span
                        class="subtitle-1 font-weight-medium px-6">+
                        Add {{ getOrdinal(additionalNominees.length + 4) }}
                        Nominee</span></v-btn>
                  </div>
                </template>
                <span>Please complete the current nominee details to add another</span>
              </v-tooltip> -->

              <div class="d-none d-md-flex mt-6">
                <v-btn height="48px" :loading="cardloader" @click="isFormInvalid ? showNomineeErrors() : setNominee()"
                  :color="isFormInvalid ? '#999' : '#000'" class="white--text text-none rounded-pill elevation-0">
                  <span class="white--text subtitle-1 font-weight-medium px-6">Continue</span>
                </v-btn>
              </div>
            </div>

            <v-footer padless color="#fff" class="btn-footer btn-footer px-3 pt-3 pb-1 d-md-none d-flex">
              <v-row no-gutters>
                <v-col cols="6" class="pr-2">
                  <v-btn v-if="activetab != 'tab2' && activetab != 'tab3'" block
                    :style="`border: 2px solid ${$v.nominee1.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                    outlined height="48px" color="#000" :disabled="$v.nominee1.$invalid || cardloader"
                    @click="(activetab = 'tab2'), (nominee1.n1_percent = 50), (nominee2.n2_percent = 50), (panel = 1), (n1_permax = 99), (n2_permax = 99), (nominee2.n2_addrCB = true), (nominee2.g2_addrCB = true), ntAdds(), gtAdds(), distributePercentages()"
                    class="text-none rounded-pill elevation-0"><span class="subtitle-1 font-weight-medium">+ Add 2nd
                      Nominee</span></v-btn>
                  <v-btn v-if="activetab == 'tab2'" block
                    :style="`border: 2px solid ${$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                    outlined height="48px" color="#000"
                    :disabled="$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader"
                    @click="(activetab = 'tab3'), (nominee1.n1_percent = 40), (nominee2.n2_percent = 30), (nominee3.n3_percent = 30), (panel = 2), (n1_permax = 98), (n2_permax = 98), (n2_permax = 98), (nominee3.n3_addrCB = true), (nominee3.g3_addrCB = true), nrAdds(), grAdds(), distributePercentages()"
                    class="text-none rounded-pill elevation-0"><span class="subtitle-1 font-weight-medium">+ Add 3rd
                      Nominee</span></v-btn>
                  <!-- Temporarily commented out - 4th+ nominee (mobile)
                  <v-tooltip bottom :disabled="isDynamicNomineesValid && !$v.nominee3.$invalid"
                    v-if="activetab == 'tab3' && additionalNominees.length + 3 < 10">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs">
                        <v-btn :disabled="!isDynamicNomineesValid || $v.nominee3.$invalid" block outlined height="48px"
                          color="#000" @click="addNominee()" class="text-none rounded-pill elevation-0"><span
                            class="subtitle-1 font-weight-medium">+
                            Add {{ getOrdinal(additionalNominees.length + 4) }}
                            Nominee</span></v-btn>
                      </div>
                    </template>
                    <span>Please complete the current nominee details to add another</span>
                  </v-tooltip> -->
                </v-col>
                <v-col cols="6" class="pl-2">
                  <v-btn height="48px" :loading="cardloader" @click="isFormInvalid ? showNomineeErrors() : setNominee()" block
                    :color="isFormInvalid ? '#999' : '#000'" class="white--text text-none rounded-pill elevation-0">
                    <span class="white--text subtitle-1 font-weight-medium">Continue</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-footer>
          </div>
        </div>
        <div v-else>
          <v-card width="100%" class="text-center py-16 elevation-0 mt-10">
            <v-progress-circular class="mx-auto" :size="60" :width="4" color="#0037B7"
              indeterminate></v-progress-circular>
          </v-card>
        </div>
      </v-col>
      <v-col cols="5" class="rgt-cols d-none d-md-block pt-0">
        <v-container fill-height class="d-block text-center">
          <img src="@/assets/nom.svg" class="rgt-img" alt="rgt-img" />
        </v-container>
      </v-col>
    </v-row>
    <div v-if="hvcompount">
      <HyperVerge @setHVstat="getHVres" :mode="'zebu_wet_nominee'" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
import { validationMixin } from "vuelidate";
import HyperVerge from "../components/HyperVerge.vue";
import { required, minLength, maxLength, between } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations() {
    var returnData = { nominee1: {}, nominee2: {}, nominee3: {} };
    const alphabetsOnly = value => {
      if (!value) return true;
      return /^[A-Za-z\s]+$/.test(value);
    };
    const validFileType = value => {
      if (!value || typeof value === 'string') return true;
      const allowed = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      return allowed.includes(value.type);
    };
    const validFileSize = value => {
      if (!value || typeof value === 'string') return true;
      return value.size <= 5 * 1024 * 1024;
    };
    const startsWithValidDigit = value => {
      if (!value) return true;
      return /^[6-9]/.test(value);
    };
    const strictEmail = value => {
      if (!value) return true;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.(com|net|org|in|co\.in|edu|gov|info|io|co|us|uk|ca|au|de|fr|jp|biz|me|tech|online|store|site|xyz)$/i;
      return emailRegex.test(value);
    };
    const isPan = (value) => {
      if (!value) return false;
      return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
    };

    const isAadhaarLast4 = (value) => {
      if (!value) return false;
      return /^[0-9]{4}$/.test(value) && /[1-9]/.test(value);
    };

    const isDrivingLicence = (value) => {
      if (!value) return false;
      return /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/.test(value);
    };

    const isPassport = (value) => {
      if (!value) return false;
      return /^[A-Z][0-9]{7}$/.test(value);
    };



    if (this.nominee1.n1_age == false) {
      returnData.nominee1 = {};
      returnData.nominee1["n1_name"] = { required, minLength: minLength(3) };
      returnData.nominee1["n1_dob"] = { required };
      returnData.nominee1["n1_relation"] = { required };
      returnData.nominee1["n1_proofType"] = { required };
      returnData.nominee1["n1_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee1.n1_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      returnData.nominee1["n1_mobile"] = { required, minLength: minLength(10), maxLength: maxLength(10), startsWithValidDigit };
      returnData.nominee1["n1_email"] = { required, strictEmail };
      returnData.nominee1["n1_percent"] = { required, between: between(1, 100) };
    } else {
      returnData.nominee1 = {};
      returnData.nominee1["n1_name"] = { required, minLength: minLength(3) };
      returnData.nominee1["n1_dob"] = { required };
      returnData.nominee1["n1_relation"] = { required };
      returnData.nominee1["n1_proofType"] = { required };
      returnData.nominee1["n1_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee1.n1_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      returnData.nominee1["n1_mobile"] = { required, minLength: minLength(10), maxLength: maxLength(10), startsWithValidDigit };
      returnData.nominee1["n1_email"] = { required, strictEmail };
      returnData.nominee1["n1_percent"] = { required, between: between(1, 100) };
      returnData.nominee1["g1_name"] = { required, minLength: minLength(3), alphabetsOnly };
      returnData.nominee1["g1_dob"] = { required };
      returnData.nominee1["g1_relation"] = { required };
      returnData.nominee1["g1_proofType"] = { required };
      returnData.nominee1["g1_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee1.g1_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      if (this.nominee1.g1_relation === 'Court-Appointed Guardian') {
        returnData.nominee1["g1_proof"] = { required, validFileType, validFileSize };
      }
    }
    if (this.nominee2.n2_age == false) {
      returnData.nominee2 = {};
      returnData.nominee2["n2_name"] = { required, minLength: minLength(3) };
      returnData.nominee2["n2_dob"] = { required };
      returnData.nominee2["n2_relation"] = { required };
      returnData.nominee2["n2_proofType"] = { required };
      returnData.nominee2["n2_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee2.n2_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      returnData.nominee2["n2_mobile"] = { required, minLength: minLength(10), maxLength: maxLength(10), startsWithValidDigit };
      returnData.nominee2["n2_email"] = { required, strictEmail };
      returnData.nominee2["n2_percent"] = { required, between: between(1, 100) };
    } else {
      returnData.nominee2 = {};
      returnData.nominee2["n2_name"] = { required, minLength: minLength(3) };
      returnData.nominee2["n2_dob"] = { required };
      returnData.nominee2["n2_relation"] = { required };
      returnData.nominee2["n2_proofType"] = { required };
      returnData.nominee2["n2_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee2.n2_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      returnData.nominee2["n2_mobile"] = { required, minLength: minLength(10), maxLength: maxLength(10), startsWithValidDigit };
      returnData.nominee2["n2_email"] = { required, strictEmail };
      returnData.nominee2["n2_percent"] = { required, between: between(1, 100) };
      returnData.nominee2["g2_name"] = { required, minLength: minLength(3), alphabetsOnly };
      returnData.nominee2["g2_dob"] = { required };
      returnData.nominee2["g2_relation"] = { required };
      returnData.nominee2["g2_proofType"] = { required };
      returnData.nominee2["g2_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee2.g2_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      if (this.nominee2.g2_relation === 'Court-Appointed Guardian') {
        returnData.nominee2["g2_proof"] = { required, validFileType, validFileSize };
      }
    }

    if (this.nominee3.n3_age == false) {
      returnData.nominee3 = {};
      returnData.nominee3["n3_name"] = { required, minLength: minLength(3) };
      returnData.nominee3["n3_dob"] = { required };
      returnData.nominee3["n3_relation"] = { required };
      returnData.nominee3["n3_proofType"] = { required };
      returnData.nominee3["n3_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee3.n3_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      returnData.nominee3["n3_mobile"] = { required, minLength: minLength(10), maxLength: maxLength(10), startsWithValidDigit };
      returnData.nominee3["n3_email"] = { required, strictEmail };
      returnData.nominee3["n3_percent"] = { required, between: between(1, 100) };
    } else {
      returnData.nominee3 = {};
      returnData.nominee3["n3_name"] = { required, minLength: minLength(3) };
      returnData.nominee3["n3_dob"] = { required };
      returnData.nominee3["n3_relation"] = { required };
      returnData.nominee3["n3_proofType"] = { required };
      returnData.nominee3["n3_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee3.n3_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      returnData.nominee3["n3_mobile"] = { required, minLength: minLength(10), maxLength: maxLength(10), startsWithValidDigit };
      returnData.nominee3["n3_email"] = { required, strictEmail };
      returnData.nominee3["n3_percent"] = { required, between: between(1, 100) };
      returnData.nominee3["g3_name"] = { required, minLength: minLength(3), alphabetsOnly };
      returnData.nominee3["g3_dob"] = { required };
      returnData.nominee3["g3_relation"] = { required };
      returnData.nominee3["g3_proofType"] = { required };
      returnData.nominee3["g3_pan"] = {
        required,
        conditionalFormat: (value) => {
          if (!value) return false;
          switch (this.nominee3.g3_proofType) {
            case "PAN":
              return isPan(value);
            case "AADHAR":
              return isAadhaarLast4(value);
            case "PROOF OF IDENTITY":
              return isDrivingLicence(value);
            case "PASSPORT":
              return isPassport(value);
            default:
              return false;
          }
        },
      };
      if (this.nominee3.g3_relation === 'Court-Appointed Guardian') {
        returnData.nominee3["g3_proof"] = { required, validFileType, validFileSize };
      }
    }
    returnData.holdPrint = { required };
    return returnData;
  },

  data: () => ({
    name: "",
    noms: [
      { txt: "Yes, Add a Nomine", val: "Yes" },
      { txt: "No, I’ll Add Later", val: "No" },
    ],
    nom: "",
    nomis: 0,
    // --- Back-office nominee pre-fill (re-activation clients only) ---
    boRekyc: false,          // client is re-active (getstart rekyc === "Yes")
    boBlocked: false,        // rejected / re-e-signed pending / has rejectiondatetime -> no pre-fill
    boGetstartDone: false,   // getstart (rekyc) resolved
    boSavedChecked: false,   // "already saved in this application?" resolved
    boHasSaved: false,       // nominees already saved in this application
    boPrefillAttempted: false,
    boPrefillNotice: "",     // "" | "filled" -> drives the info box
    boPrefillBuilt: [],      // back-office nominees, kept to re-fill after the form is cleared
    /////////////////
    panel: 0,
    tab: null,
    activePicker: null,
    // menu: false,
    cardloader: false,
    nomineeclearalert: false,
    lastFetchedPincode: {},
    pincodePostOffices: {},
    n1_menu: false,
    n2_menu: false,
    n3_menu: false,
    g1_menu: false,
    g2_menu: false,
    g3_menu: false,
    activetab: "",
    holdPrint: "",
    relationitems: ["Father", "Mother", "Brother", "Sister", "Son", "Daughter", "Husband", "Wife", "Grand-Father", "Grand-Mother", "Grand-Son", "Grand-Daughter"],
    guardianrelationitems: ["Father", "Mother", "Son", "Daughter", "Brother", "Sister", "Grand-Father", "Grand-Mother", "Grand-Son", "Grand-Daughter", "Court-Appointed Guardian"],
    proffitems: [{ "type": "PAN", "value": "PAN Number" }, { "type": "AADHAR", "value": "Aadhaar number(last 4 digits)" }, { "type": "PROOF OF IDENTITY", "value": "Driving Licence Number" }, { "type": "PASSPORT", "value": "Passport Number" }],
    nominee1: {
      n1_name: "",
      n1_email: "",
      n1_mobile: "",
      n1_pan: "",
      n1_dob: "",
      n1_age: "",
      n1_relation: "",
      n1_percent: 100,
      n1_addrCB: true,
      n1_addr: "",
      n1_addr2: "",
      n1_city: "",
      n1_state: "",
      n1_country: "",
      n1_pincode: "",
      n1_proofType: "AADHAR",
      n1_proof: "",
      n1_hold_print: "",
      g1_name: "",
      g1_email: "",
      g1_mobile: "",
      g1_dob: "",
      g1_relation: "",
      g1_addrCB: true,
      g1_addr: "",
      g1_city: "",
      g1_state: "",
      g1_country: "",
      g1_pincode: "",
      g1_proofType: "AADHAR",
      g1_pan: "",
      g1_proof: null,
    },
    nominee2: {
      n2_name: "",
      n2_email: "",
      n2_mobile: "",
      n2_pan: "",
      n2_dob: "",
      n2_age: "",
      n2_relation: "",
      n2_percent: "",
      n2_addrCB: true,
      n2_addr: "",
      n2_addr2: "",
      n2_city: "",
      n2_state: "",
      n2_country: "",
      n2_pincode: "",
      n2_proofType: "AADHAR",
      n2_proof: "",
      n2_hold_print: "",
      g2_name: "",
      g2_email: "",
      g2_mobile: "",
      g2_dob: "",
      g2_relation: "",
      g2_addrCB: true,
      g2_addr: "",
      g2_city: "",
      g2_state: "",
      g2_country: "",
      g2_pincode: "",
      g2_proofType: "AADHAR",
      g2_pan: "",
      g2_proof: null,
    },
    nominee3: {
      n3_name: "",
      n3_email: "",
      n3_mobile: "",
      n3_pan: "",
      n3_dob: "",
      n3_age: "",
      n3_relation: "",
      n3_percent: "",
      n3_addrCB: true,
      n3_addr: "",
      n3_addr2: "",
      n3_city: "",
      n3_state: "",
      n3_country: "",
      n3_pincode: "",
      n3_proofType: "AADHAR",
      n3_proof: "",
      n3_hold_print: "",
      g3_name: "",
      g3_email: "",
      g3_mobile: "",
      g3_dob: "",
      g3_relation: "",
      g3_addrCB: true,
      g3_addr: "",
      g3_city: "",
      g3_state: "",
      g3_country: "",
      g3_pincode: "",
      g3_proofType: "AADHAR",
      g3_pan: "",
      g3_proof: null,
    },
    nomi1: {
      n1_name: "",
      n1_email: "",
      n1_mobile: "",
      n1_pan: "",
      n1_dob: "",
      n1_age: "",
      n1_relation: "",
      n1_percent: "",
      n1_addrCB: "",
      n1_addr: "",
      n1_addr2: "",
      n1_city: "",
      n1_state: "",
      n1_country: "",
      n1_pincode: "",
      n1_proofType: "",
      n1_proof: "",
      n1_hold_print: "",
      g1_name: "",
      g1_email: "",
      g1_mobile: "",
      g1_dob: "",
      g1_relation: "",
      g1_addrCB: "",
      g1_addr: "",
      g1_city: "",
      g1_state: "",
      g1_country: "",
      g1_pincode: "",
    },
    nomi2: {
      n2_name: "",
      n2_email: "",
      n2_mobile: "",
      n2_pan: "",
      n2_dob: "",
      n2_age: "",
      n2_relation: "",
      n2_percent: "",
      n2_addrCB: "",
      n2_addr: "",
      n2_addr2: "",
      n2_city: "",
      n2_state: "",
      n2_country: "",
      n2_pincode: "",
      n2_proofType: "",
      n2_proof: "",
      n2_hold_print: "",
      g2_name: "",
      g2_email: "",
      g2_mobile: "",
      g2_dob: "",
      g2_relation: "",
      g2_addrCB: "",
      g2_addr: "",
      g2_city: "",
      g2_state: "",
      g2_country: "",
      g2_pincode: "",
    },
    nomi3: {
      n3_name: "",
      n3_email: "",
      n3_mobile: "",
      n3_pan: "",
      n3_dob: "",
      n3_age: "",
      n3_relation: "",
      n3_percent: "",
      n3_addrCB: "",
      n3_addr: "",
      n3_addr2: "",
      n3_city: "",
      n3_state: "",
      n3_country: "",
      n3_pincode: "",
      n3_proofType: "",
      n3_proof: "",
      n3_hold_print: "",
      g3_name: "",
      g3_email: "",
      g3_mobile: "",
      g3_dob: "",
      g3_relation: "",
      g3_addrCB: "",
      g3_addr: "",
      g3_city: "",
      g3_state: "",
      g3_country: "",
      g3_pincode: "",
    },
    additionalNominees: [],
    percentManualEdit: { n1: false, n2: false, n3: false },

    gud: {
      g1: {
        g1_name: "",
        g1_email: "",
        g1_mobile: "",
        g1_dob: "",
        g1_relation: "",
        g1_addrCB: "",
        g1_addr: "",
        g1_city: "",
        g1_state: "",
        g1_country: "",
        g1_pincode: "",
        g1_proofType: "",
        g1_pan: "",
      },
      g2: {
        g2_name: "",
        g2_email: "",
        g2_mobile: "",
        g2_dob: "",
        g2_relation: "",
        g2_addrCB: "",
        g2_addr: "",
        g2_city: "",
        g2_state: "",
        g2_country: "",
        g2_pincode: "",
        g2_proofType: "",
        g2_pan: "",
      },
      g3: {
        g3_name: "",
        g3_email: "",
        g3_mobile: "",
        g3_dob: "",
        g3_relation: "",
        g3_addrCB: "",
        g3_addr: "",
        g3_city: "",
        g3_state: "",
        g3_country: "",
        g3_pincode: "",
        g3_proofType: "",
        g3_pan: "",
      },
    },

    n1_permin: 1,
    n2_permin: 1,
    n3_permin: 1,
    n1_permax: 100,
    n2_permax: 50,
    n3_permax: 30,
    sameaddress: {},
    agevalid: `${new Date().getFullYear() - 18}`,
    changenominee: false,

    dataloader: null,
    rejectdata: [],
    getstatresponce: [],
    hvcompount: false,
    hypervegestarted: false,
    showHypervergeFlow: false,
    mainnomineeselect: true,
    hypervergeresult: false,
    hypervergresdata: [],
    hyperflowloadd: false,
    hypervegenonres: [],
    clientName: "",
    clientDob: "",
    clientEmail: "",
    clientPan: "",
    clientAadhaarLast4: "",
    clientMobile: "",
    clientAadhaarName: ""
  }),
  components: {
    // vueSignature,
    HyperVerge,
  },
  created() {
    this.getstatresponce = []
    let config = {
      method: "post",
      url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")),
      headers: {
        "Content-Type": "application/json",
        "mobile": atob(localStorage.getItem("hash"))
      },
    };

    let axiosThis = this;
    axios
      .request(config)
      .then((response) => {
        axiosThis.getstatresponce = response.data
        axiosThis.boRekyc = !!(response.data && ((response.data.rekyc == "Yes") || (response.data.data_type && response.data.data_type.rekyc == "Yes")));
        // Don't pre-fill once the application is in a rejected / re-e-sign correction
        // cycle (these carry a rejectiondatetime) -> leave the normal flow.
        axiosThis.boBlocked = !!(response.data && (
          response.data.app_status == "rejected" ||
          response.data.app_status == "re-e-signed pending" ||
          response.data.rejectiondatetime ||
          (response.data.data_type && response.data.data_type.rejectiondatetime)
        ));
        axiosThis.boGetstartDone = true;
        axiosThis.tryBoPrefill();
        if (response.data) {
          if (response.data.email) axiosThis.clientEmail = response.data.email.toString().trim();
          if (response.data.mobile_no) axiosThis.clientMobile = response.data.mobile_no.toString().replace(/\D/g, "");
          if (response.data.panname) axiosThis.clientName = response.data.panname.toString().trim();
          if (response.data.dob) axiosThis.clientDob = response.data.dob.toString().trim();
          if (response.data.pan_no) {
            try { axiosThis.clientPan = atob(response.data.pan_no).toString().trim(); } catch (e) { axiosThis.clientPan = response.data.pan_no.toString().trim(); }
          }
          if (response.data.aadhar_no) {
            var digits = response.data.aadhar_no.toString().replace(/\D/g, "");
            axiosThis.clientAadhaarLast4 = digits.slice(-4);
          }
          if (response.data.aadhaar_name) axiosThis.clientAadhaarName = response.data.aadhaar_name.toString().trim();
        }
        let p = response.data.data_type;
        if (response.data.data_type && response.data.stage_wise_approval.nominee != "yes" && response.data.kra_esigned != 'Yes' && (p.stage == "nominee" || p.stage == "selfie" || p.stage == "submit")) {
          axiosThis.$emit("clicked", 5, response.data);
          if (p.check && p.check.nominee_proof == "yes") {
            axiosThis.nomineeclearalert = true;
            axiosThis.hypervergeresult = false;
            axiosThis.showHypervergeFlow = false;
            axiosThis.mainnomineeselect = true;
            axiosThis.$emit("changed", 5);
          }
          response.data.app_status == "rejected" && response.data.stage_wise_approval.nominee == "no" ? (axiosThis.rejectdata = response.data) : (axiosThis.rejectdata = []);
        } else {
          axiosThis.$router.push(p ? { name: p.stage } : "/");
        }
      })
      .catch((error) => {
        console.log(error);
        axiosThis.boGetstartDone = true;
        axiosThis.tryBoPrefill();
        axiosThis.$emit("snack", 0, error);
      });
  },
  methods: {
    showNomineeErrors() {
      this.$v.$touch();
      if (this.formErrorSummary) {
        let lines = this.formErrorSummary.split(' | ');
        this.$emit("snack", 0, lines.join('\n'));
      }
    },
    getMissingFields(nominee, prefix) {
      const fieldLabels = {
        [`${prefix}_name`]: 'Name',
        [`${prefix}_dob`]: 'Date of Birth',
        [`${prefix}_relation`]: 'Relationship',
        [`${prefix}_percent`]: 'Percentage',
        [`${prefix}_mobile`]: 'Mobile',
        [`${prefix}_email`]: 'Email',
        [`${prefix}_proofType`]: 'Proof Type',
        [`${prefix}_pan`]: 'Proof Number',
        [`${prefix}_hold_print`]: 'Nomination details to be printed in the account / holding statements',
        [`${prefix}_addr`]: 'Address',
        [`${prefix}_city`]: 'City',
        [`${prefix}_state`]: 'State',
        [`${prefix}_country`]: 'Country',
        [`${prefix}_pincode`]: 'Pincode',
      };
      const gPrefix = prefix.replace('n', 'g');
      const guardianLabels = {
        [`${gPrefix}_name`]: 'Guardian Name',
        [`${gPrefix}_dob`]: 'Guardian DOB',
        [`${gPrefix}_relation`]: 'Guardian Relationship',
        [`${gPrefix}_addr`]: 'Guardian Address',
        [`${gPrefix}_city`]: 'Guardian City',
        [`${gPrefix}_state`]: 'Guardian State',
        [`${gPrefix}_country`]: 'Guardian Country',
        [`${gPrefix}_pincode`]: 'Guardian Pincode',
        [`${gPrefix}_proof`]: 'Court Order File',
      };
      const allLabels = { ...fieldLabels, ...guardianLabels };
      const missing = [];
      for (const [field, label] of Object.entries(allLabels)) {
        if (nominee[field] && nominee[field].$invalid) {
          missing.push(label);
        }
      }
      return missing.length > 0 ? missing.join(', ') + ' required' : 'Please fill all details';
    },

    hypervergetsta() {

      console.log("33333iff");
      var axiosThis = this;
      let datao = JSON.stringify({
        nomineehyper: this.hypervergresdata,
        nomineehypersat: true,
      });
      let configo = {
        method: "post",
        url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")) + `&type=add`,
        headers: {
          "Content-Type": "application/json",
          "mobile": atob(localStorage.getItem("hash"))
        },
        data: datao,
      };
      axios
        .request(configo)
        .then((response) => {
          console.log("responsenewww", response);

          if (response.data) {
            axiosThis.toNext();
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.$emit("snack", 0, error);
        });
      // axiosThis.$emit("snack", 1, response.data.status ? `Consent can be submitted Successfully` : response.data);

    },

    hypervergetstainnominee() {

      console.log("33333iff");
      var axiosThis = this;
      let datao = JSON.stringify({
        nomineehyper: [],
        nomineehypersat: false,
      });
      let configo = {
        method: "post",
        url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")) + `&type=add`,
        headers: {
          "Content-Type": "application/json",
          "mobile": atob(localStorage.getItem("hash"))
        },
        data: datao,
      };
      axios
        .request(configo)
        .then((response) => {
          console.log("responsenewwwinnnn", response);

          // if (response.data) {
          //   axiosThis.toNext();
          // }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.$emit("snack", 0, error);
        });
      // axiosThis.$emit("snack", 1, response.data.status ? `Consent can be submitted Successfully` : response.data);

    },

    async getHVres(res, clr, msg) {
      this.hypervergresdata = res;
      console.log("sssssssssssssssssssdsddbn", res, "mss", msg, "clrrrr", clr);
      if (res && clr != 1) {
        this.hyperflowloadd = false;
        this.hvcompount = false;
        this.hypervergeresult = false;
        this.showHypervergeFlow = false;
        this.mainnomineeselect = true;
        this.nomineeclearalert = true;
        this.$emit("snack", 0, msg || "Video verification failed, please try again.");
        return;
      }

      if (res) {
        let data = JSON.stringify({
          'hyp_resp': res,
          "mobile": atob(localStorage.getItem("hash"))
        });

        let axiosThis = this;
        let config = {
          method: "post",
          url: api.api_url + `/HypervergeVideoStatement`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        await axios
          .request(config)
          .then((response) => {
            console.log("sssssssssssssssssss", response.data, res.status);
            axiosThis.hyperflowloadd = false;

            if (response) {
              console.log("1111111111ifff ");



              if (response.data && response.data.message == 'Video downloaded') {
                console.log("ifff nomeniwwwwww comeeeeee");

                axiosThis.$emit("snack", 1, response.data.message);
                axiosThis.mainnomineeselect = false
                axiosThis.showHypervergeFlow = false;
                axiosThis.hypervergeresult = true;
                axiosThis.nomineeclearalert = false;
                axiosThis.hvcompount = false;

              } else {
                console.log("1lessssss");

                axiosThis.$emit("snack", 0, response.data ? response.data : msg);
                axiosThis.hypervergetstainnominee()
                axiosThis.hvcompount = false;
              }
            }
          })
          .catch((error) => {
            console.log("1catccccc");
            axiosThis.hypervergetstainnominee()
            axiosThis.hyperflowloadd = false;

            console.log(error);
            axiosThis.$emit("snack", 0, error);
            axiosThis.hvcompount = false;
          });
      } else {
        console.log("elseeeeeeeeeeeeeeeeeeeeeeeeee");

        this.$emit("snack", 0, msg);
        this.hvcompount = false;
      }

    },
    formatDate(date) {
      console.log("datae", date);
      console.log("datae tytoe", typeof date);


      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },

    handleInputN1() {
      const regex = /^[a-zA-Z]. *$/;

      if (!regex.test(this.nominee1.n1_name)) {
        this.$nextTick(() => {
          this.nominee1.n1_name = '';
        });
      }
      if (!regex.test(this.nominee2.n2_name)) {
        this.$nextTick(() => {
          this.nominee2.n2_name = '';
        });
      }
      if (!regex.test(this.nominee3.n3_name)) {
        this.$nextTick(() => {
          this.nominee3.n3_name = '';
        });
      }
    },

    handlePaste(event) {
      const pastedText = event.clipboardData.getData('text');
      const regex = /[^a-zA-Z]/g;
      if (regex.test(pastedText)) {
        if (this.nomis == 0) {
          this.nominee1.n1_name = '';
        } if (this.nomis == 1) {
          this.nominee2.n2_name = '';
        } if (this.nomis == 2) {
          this.nominee3.n3_name = '';
        }
        event.preventDefault();
      }
    },
    handlePasteadd(event) {
      const pastedText = event.clipboardData.getData('text');
      const regex = /[^a-zA-Z]/g;
      if (regex.test(pastedText)) {
        if (this.nomis == 0) {
          this.nominee1.n1_addr = '';
        } if (this.nomis == 1) {
          this.nominee2.n2_addr = '';
        } if (this.nomis == 2) {
          this.nominee3.n3_addr = '';
        }
        event.preventDefault();
      }
    },
    pincodeValid(pc, e, type) {
      let nomineeObj = type == "n1" || type == "g1" ? this.nominee1 : type == "n2" || type == "g2" ? this.nominee2 : this.nominee3;
      let poc = nomineeObj[`${type}_pincode`];
      if (poc && poc.toString().length > 6) {
        nomineeObj[`${type}_pincode`] = poc.toString().slice(0, 6);
        poc = nomineeObj[`${type}_pincode`];
      }
      if (poc && poc.toString().length <= 6) {
        if (poc.toString().length == 6) {
          if (this.lastFetchedPincode && this.lastFetchedPincode[type] == poc.toString()) return;
          if (!this.lastFetchedPincode) this.lastFetchedPincode = {};
          this.lastFetchedPincode[type] = poc.toString();

          let config = {
            method: "get",
            url: `https://api.postalpincode.in/pincode/${poc}`,
          };

          let axiosThis = this;
          axios
            .request(config)
            .then((response) => {
              if (response.data && response.data[0].Status == "Success" && response.data[0].PostOffice && response.data[0].PostOffice.length > 0) {
                let postOffices = response.data[0].PostOffice;
                nomineeObj[`${type}_pincode`] = postOffices[0].Pincode != "NA" ? postOffices[0].Pincode : "";
                if (postOffices.length > 1) {
                  axiosThis.$set(axiosThis.pincodePostOffices, type, postOffices.map(po => po.Name));
                  nomineeObj[`${type}_city`] = "";
                  nomineeObj[`${type}_state`] = postOffices[0].State != "NA" ? postOffices[0].State : "";
                  nomineeObj[`${type}_country`] = postOffices[0].Country != "NA" ? postOffices[0].Country : "";
                } else {
                  axiosThis.$set(axiosThis.pincodePostOffices, type, []);
                  nomineeObj[`${type}_city`] = postOffices[0].Name != "NA" ? postOffices[0].Name : "";
                  nomineeObj[`${type}_state`] = postOffices[0].State != "NA" ? postOffices[0].State : "";
                  nomineeObj[`${type}_country`] = postOffices[0].Country != "NA" ? postOffices[0].Country : "";
                }
              } else {
                nomineeObj[`${type}_city`] = "";
                nomineeObj[`${type}_state`] = "";
                nomineeObj[`${type}_country`] = "";
                axiosThis.$set(axiosThis.pincodePostOffices, type, []);
                axiosThis.$emit("snack", 0, "Invalid Pincode. Please enter a valid pincode.");
              }
            })
            .catch((error) => {
              console.log(error, e, pc);
            });
        }
      } else {
        e.preventDefault();
      }
    },
    proofInputFilter(value, proofType, nomineeKey, field) {
      if (!value) return;
      let filtered = value.trim();
      if (proofType === 'PAN') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
      } else if (proofType === 'AADHAR') {
        filtered = filtered.replace(/[^0-9]/g, '').slice(0, 4);
      } else if (proofType === 'PROOF OF IDENTITY') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '');
        let letters = filtered.replace(/[^A-Z]/g, '').slice(0, 2);
        let digits = filtered.replace(/[^0-9]/g, '').slice(0, 13);
        filtered = (letters + digits).slice(0, 15);
      } else if (proofType === 'PASSPORT') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
      }
      if (nomineeKey && field) {
        this.$nextTick(() => {
          this[nomineeKey][field] = filtered;
        });
      }
    },
    proofKeypress(e, proofType) {
      let char = String.fromCharCode(e.keyCode || e.which);
      if (proofType === 'AADHAR') {
        if (!/^[0-9]$/.test(char)) e.preventDefault();
      } else if (proofType === 'PAN') {
        if (!/^[A-Za-z0-9]$/.test(char)) e.preventDefault();
      } else if (proofType === 'PROOF OF IDENTITY') {
        let currentLen = e.target.value.length;
        if (currentLen < 2) {
          if (!/^[A-Za-z]$/.test(char)) e.preventDefault();
        } else {
          if (!/^[0-9]$/.test(char)) e.preventDefault();
        }
      } else if (proofType === 'PASSPORT') {
        if (!/^[A-Za-z0-9]$/.test(char)) e.preventDefault();
      }
    },
    clearProofValue(nomineeKey, field) {
      this[nomineeKey][field] = '';
      if (this.$v[nomineeKey] && this.$v[nomineeKey][field]) {
        this.$v[nomineeKey][field].$reset();
      }
    },
    clearDynamicProofValue(index) {
      this.additionalNominees[index].proof = '';
    },
    dynamicProofInputFilter(index, proofType) {
      let value = this.additionalNominees[index].proof;
      if (!value) return;
      let filtered = value.trim();
      if (proofType === 'PAN') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
      } else if (proofType === 'AADHAR') {
        filtered = filtered.replace(/[^0-9]/g, '').slice(0, 4);
      } else if (proofType === 'PROOF OF IDENTITY') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '');
        let letters = filtered.replace(/[^A-Z]/g, '').slice(0, 2);
        let digits = filtered.replace(/[^0-9]/g, '').slice(0, 13);
        filtered = (letters + digits).slice(0, 15);
      } else if (proofType === 'PASSPORT') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
      }
      this.$nextTick(() => {
        this.additionalNominees[index].proof = filtered;
      });
    },
    clearDynamicGProofValue(index) {
      this.additionalNominees[index].g_pan = '';
    },
    dynamicGProofInputFilter(index) {
      let proofType = this.additionalNominees[index].g_proofType;
      let value = this.additionalNominees[index].g_pan;
      if (!value) return;
      let filtered = value.trim();
      if (proofType === 'PAN') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
      } else if (proofType === 'AADHAR') {
        filtered = filtered.replace(/[^0-9]/g, '').slice(0, 4);
      } else if (proofType === 'PROOF OF IDENTITY') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '');
        let letters = filtered.replace(/[^A-Z]/g, '').slice(0, 2);
        let digits = filtered.replace(/[^0-9]/g, '').slice(0, 13);
        filtered = (letters + digits).slice(0, 15);
      } else if (proofType === 'PASSPORT') {
        filtered = filtered.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
      }
      this.$nextTick(() => {
        this.additionalNominees[index].g_pan = filtered;
      });
    },
    isDigit(e) {
      let char = String.fromCharCode(e.keyCode || e.which);
      if (!/^[0-9]$/.test(char)) e.preventDefault();
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z\s]$/.test(char) || char == " ") return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

    toNext() {
      if (this.rejectdata.app_status == "rejected" && this.rejectdata.stage_wise_approval.nominee == "no") {
        this.$emit("steged", "nominee");
      } else {
        this.$emit("clicked", "selfie");
      }
    },
    hypervegeflowst() {
      console.log("hyyy follllll");
      this.mainnomineeselect = false
      this.showHypervergeFlow = true
    },
    nomineeUpdation() {
      console.log("djhsdjsdvdj", this.nom);
      // if (atob(localStorage.getItem("hash")) && this.nom) {
      //   this.cardloader = true;
      //   var axiosThis = this;
      //   var json_data = {
      //     mobile: atob(localStorage.getItem("hash")),
      //     nominee_check: axiosThis.nom,
      //   };
      //   var config = {
      //     method: "post",
      //     url: api.api_url + "/signupGetUserPersonalDetails",
      //     headers: { "Content-Type": "application/json", "mobile": atob(localStorage.getItem("hash")) },
      //     data: JSON.stringify(json_data),
      //   };
      //   axios(config)
      //     .then(function (response) {
      //       if (response.data && response.data.data == "User data has been inserted successfully") {
      //         if (axiosThis.nom == "No") {
      //           // axiosThis.toNext();
      //           axiosThis.hypervegeflowst()
      //         } else if (axiosThis.nom == "Yes") {
      //           axiosThis.showHypervergeFlow = false
      //           axiosThis.nomis = 1;
      //           axiosThis.nominee1.n1_percent = 100;
      //           axiosThis.getSameaddress();
      //         }
      //       } else {
      //         axiosThis.$emit("snack", 0, response.data);
      //       }
      //       axiosThis.cardloader = false;
      //     })
      //     .catch(function (error) {
      //       console.log(error);
      //       axiosThis.cardloader = false;
      //       axiosThis.$emit("snack", 0, error);
      //     });
      // }
      var axiosThis = this
      // if (response.data && response.data.data == "User data has been inserted successfully") {
      if (axiosThis.nom == "No") {
        // axiosThis.toNext();
        axiosThis.hypervegeflowst()
      } else if (axiosThis.nom == "Yes") {
        axiosThis.showHypervergeFlow = false
        axiosThis.nomis = 1;
        axiosThis.nominee1.n1_percent = 100;
        // Re-pull the back-office nominees when re-adding -> only for re-KYC clients
        // (rekyc == "Yes") with nothing saved (signupGetNomineeDetails empty = !boHasSaved)
        // and not in a reject/re-e-sign cycle, and only when the form was just cleared.
        if (axiosThis.boRekyc && !axiosThis.boBlocked && !axiosThis.boHasSaved &&
            axiosThis.boPrefillBuilt.length && !axiosThis.nominee1.n1_name) {
          axiosThis.applyBoPrefill(axiosThis.boPrefillBuilt);
        }
        axiosThis.getSameaddress();
      }
      // } else {
      //   axiosThis.$emit("snack", 0, response.data);
      // }
      axiosThis.cardloader = false;
      console.log("djdbdbk");
      // this.hvcompount = true
    },
    connecthypervegefun() {
      this.hyperflowloadd = true;
      // Reset hvcompount first to ensure HyperVerge reinitializes properly
      this.hvcompount = false
      // Use nextTick to ensure the component is fully destroyed before recreating
      this.$nextTick(() => {
        this.hvcompount = true
      })
    },
    clearTabo() {
      // axios.post(api.api_url + "/clear_stage_data", {
      //   mobile: atob(localStorage.getItem("hash")),
      //   type: "nominee",
      //   upload: true,
      // });
      this.showHypervergeFlow = false
      this.activetab = "";
      // Clone (don't share nomi1 by reference) so re-filling nominee1 later can't
      // dirty the empty template -> keeps the "form was cleared" guard reliable.
      this.nominee1 = JSON.parse(JSON.stringify(this.nomi1));
      // Fully clear nominee 2 & 3 too, otherwise pre-filled values linger (hidden)
      // and resurface as stale data if the user adds them again after "close all".
      const blankNom = (n, p) => {
        n[`${p}_name`] = ""; n[`${p}_relation`] = ""; n[`${p}_dob`] = "";
        n[`${p}_age`] = ""; n[`${p}_mobile`] = ""; n[`${p}_email`] = "";
        n[`${p}_pan`] = ""; n[`${p}_percent`] = ""; n[`${p}_proofType`] = "AADHAR";
      };
      blankNom(this.nominee2, "n2");
      blankNom(this.nominee3, "n3");
      this.nomis = "";
      this.nom = "";
      this.additionalNominees = []; // Clear dynamic nominees
      this.percentManualEdit = { n1: false, n2: false, n3: false };
      this.boPrefillNotice = ""; // form is empty now -> drop "we found your details"
      this.$v.$reset();
    },
    clearNomineeVideo() {
      axios.post(api.api_url + "/clear_stage_data", {
        mobile: atob(localStorage.getItem("hash")),
        type: "nominee",
        upload: true,
      });
      this.hypervergeresult = false;
      this.showHypervergeFlow = false;
      this.mainnomineeselect = true;
      this.nomineeclearalert = true;
    },
    clearTabt() {
      this.activetab = "";
      this.nominee2 = this.nomi2;
      this.nominee1.n1_percent = 100;
      this.nominee2.n2_percent = "";
      this.nominee3.n3_percent = "";
      this.additionalNominees = []; // Clear dynamic nominees
      this.percentManualEdit = { n1: false, n2: false, n3: false };
      this.panel = 0;
      this.distributePercentages();
    },
    clearTabr() {
      this.activetab = "tab2";
      this.nominee3 = this.nomi3;
      this.nominee1.n1_percent = 50;
      this.nominee2.n2_percent = 50;
      this.nominee3.n3_percent = "";
      this.additionalNominees = []; // Clear dynamic nominees
      this.percentManualEdit = { n1: false, n2: false, n3: false };
      this.panel = 1;
      this.distributePercentages();
    },

    nomPerChgo() {
      this.percentManualEdit.n1 = true;
      let totalDynamic = this.additionalNominees.reduce((sum, n) => sum + Number(n.percent), 0);
      let manualTotal = Number(this.nominee1.n1_percent) + totalDynamic;
      if (this.percentManualEdit.n2) manualTotal += Number(this.nominee2.n2_percent) || 0;
      if (this.percentManualEdit.n3) manualTotal += Number(this.nominee3.n3_percent) || 0;
      let remaining = 100 - manualTotal;

      if (this.activetab == "tab3") {
        this.n1_permax = 98;
        this.n2_permax = 98;
        this.n3_permax = 98;
        let autoCount = (!this.percentManualEdit.n2 ? 1 : 0) + (!this.percentManualEdit.n3 ? 1 : 0);
        if (autoCount > 0) {
          let share = remaining / autoCount;
          if (!this.percentManualEdit.n2) this.nominee2.n2_percent = share;
          if (!this.percentManualEdit.n3) this.nominee3.n3_percent = share;
        }
      } else if (this.activetab == "tab2") {
        this.n1_permax = 99;
        this.n2_permax = 99;
        if (!this.percentManualEdit.n2) this.nominee2.n2_percent = remaining;
      }
    },
    nomPerChgt() {
      this.percentManualEdit.n2 = true;
      let totalDynamic = this.additionalNominees.reduce((sum, n) => sum + Number(n.percent), 0);
      let manualTotal = Number(this.nominee2.n2_percent) + totalDynamic;
      if (this.percentManualEdit.n1) manualTotal += Number(this.nominee1.n1_percent) || 0;
      if (this.percentManualEdit.n3) manualTotal += Number(this.nominee3.n3_percent) || 0;
      let remaining = 100 - manualTotal;

      if (this.activetab == "tab3") {
        this.n1_permax = 98;
        this.n2_permax = 98;
        this.n3_permax = 98;
        let autoCount = (!this.percentManualEdit.n1 ? 1 : 0) + (!this.percentManualEdit.n3 ? 1 : 0);
        if (autoCount > 0) {
          let share = remaining / autoCount;
          if (!this.percentManualEdit.n1) this.nominee1.n1_percent = share;
          if (!this.percentManualEdit.n3) this.nominee3.n3_percent = share;
        }
      } else if (this.activetab == "tab2") {
        this.n1_permax = 99;
        this.n2_permax = 99;
        if (!this.percentManualEdit.n1) this.nominee1.n1_percent = remaining;
      }
    },
    nomPerChgr() {
      this.percentManualEdit.n3 = true;
      this.n1_permax = 98;
      this.n2_permax = 98;
      this.n3_permax = 98;
      let totalDynamic = this.additionalNominees.reduce((sum, n) => sum + Number(n.percent), 0);
      let manualTotal = Number(this.nominee3.n3_percent) + totalDynamic;
      if (this.percentManualEdit.n1) manualTotal += Number(this.nominee1.n1_percent) || 0;
      if (this.percentManualEdit.n2) manualTotal += Number(this.nominee2.n2_percent) || 0;
      let remaining = 100 - manualTotal;

      let autoCount = (!this.percentManualEdit.n1 ? 1 : 0) + (!this.percentManualEdit.n2 ? 1 : 0);
      if (autoCount > 0) {
        let share = remaining / autoCount;
        if (!this.percentManualEdit.n1) this.nominee1.n1_percent = share;
        if (!this.percentManualEdit.n2) this.nominee2.n2_percent = share;
      }
    },
    noAdds() {
      if (this.nominee1.n1_percent > 0 && this.nominee1.n1_addrCB == true) {
        this.nominee1.n1_addr = this.sameaddress.address;
        this.nominee1.n1_city = this.sameaddress.city;
        this.nominee1.n1_state = this.sameaddress.state;
        this.nominee1.n1_country = this.sameaddress.country;
        this.nominee1.n1_pincode = this.sameaddress.pincode;
      } else {
        this.nominee1.n1_addr = "";
        this.nominee1.n1_city = "";
        this.nominee1.n1_state = "";
        this.nominee1.n1_country = "";
        this.nominee1.n1_pincode = "";
      }
    },
    goAdds() {
      if (this.nominee1.n1_age && this.nominee1.g1_addrCB) {
        this.nominee1.g1_addr = this.sameaddress.address;
        this.nominee1.g1_city = this.sameaddress.city;
        this.nominee1.g1_state = this.sameaddress.state;
        this.nominee1.g1_country = this.sameaddress.country;
        this.nominee1.g1_pincode = this.sameaddress.pincode;
      } else {
        this.nominee1.g1_addr = "";
        this.nominee1.g1_city = "";
        this.nominee1.g1_state = "";
        this.nominee1.g1_country = "";
        this.nominee1.g1_pincode = "";
      }
    },
    ntAdds() {
      if (this.nominee2.n2_percent > 0 && this.nominee2.n2_addrCB == true) {
        this.nominee2.n2_addr = this.sameaddress.address;
        this.nominee2.n2_city = this.sameaddress.city;
        this.nominee2.n2_state = this.sameaddress.state;
        this.nominee2.n2_country = this.sameaddress.country;
        this.nominee2.n2_pincode = this.sameaddress.pincode;
      } else {
        this.nominee2.n2_addr = "";
        this.nominee2.n2_city = "";
        this.nominee2.n2_state = "";
        this.nominee2.n2_country = "";
        this.nominee2.n2_pincode = "";
      }
    },
    gtAdds() {
      if (this.nominee2.n2_age && this.nominee2.g2_addrCB) {
        this.nominee2.g2_addr = this.sameaddress.address;
        this.nominee2.g2_city = this.sameaddress.city;
        this.nominee2.g2_state = this.sameaddress.state;
        this.nominee2.g2_country = this.sameaddress.country;
        this.nominee2.g2_pincode = this.sameaddress.pincode;
      } else {
        this.nominee2.g2_addr = "";
        this.nominee2.g2_city = "";
        this.nominee2.g2_state = "";
        this.nominee2.g2_country = "";
        this.nominee2.g2_pincode = "";
      }
    },
    nrAdds() {
      if (this.nominee3.n3_percent > 0 && this.nominee3.n3_addrCB == true) {
        this.nominee3.n3_addr = this.sameaddress.address;
        this.nominee3.n3_city = this.sameaddress.city;
        this.nominee3.n3_state = this.sameaddress.state;
        this.nominee3.n3_country = this.sameaddress.country;
        this.nominee3.n3_pincode = this.sameaddress.pincode;
      } else {
        this.nominee3.n3_addr = "";
        this.nominee3.n3_city = "";
        this.nominee3.n3_state = "";
        this.nominee3.n3_country = "";
        this.nominee3.n3_pincode = "";
      }
    },
    grAdds() {
      if (this.nominee3.n3_age && this.nominee3.g3_addrCB) {
        this.nominee3.g3_addr = this.sameaddress.address;
        this.nominee3.g3_city = this.sameaddress.city;
        this.nominee3.g3_state = this.sameaddress.state;
        this.nominee3.g3_country = this.sameaddress.country;
        this.nominee3.g3_pincode = this.sameaddress.pincode;
      } else {
        this.nominee3.g3_addr = "";
        this.nominee3.g3_city = "";
        this.nominee3.g3_state = "";
        this.nominee3.g3_country = "";
        this.nominee3.g3_pincode = "";
      }
    },
    getSameaddress() {
      let config = {
        method: "post",
        url: api.api_url + "/sameAsAddress",
        headers: {
          "Content-Type": "application/json",
          "mobile": atob(localStorage.getItem("hash"))
        },
        data: JSON.stringify({
          mob: atob(localStorage.getItem("hash")),
        }),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data.address) {
            axiosThis.sameaddress = response.data;
            if (axiosThis.nominee1.g1_addrCB) axiosThis.goAdds();
            if (axiosThis.nominee1.n1_addrCB) axiosThis.noAdds();
            if (axiosThis.nominee2.g2_addrCB) axiosThis.gtAdds();
            if (axiosThis.nominee2.n2_addrCB) axiosThis.ntAdds();
            if (axiosThis.nominee3.g3_addrCB) axiosThis.grAdds();
            if (axiosThis.nominee3.n3_addrCB) axiosThis.nrAdds();
          }
          axiosThis.cardloader = false;
          axiosThis.dataloader = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.$emit("snack", 0, error);
        });
    },
    differentDate(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      var yy = (Math.abs(date1 - date2) / (1000 * 60 * 60 * 24) - 5) / 365;
      return yy != 0 ? yy : 0;
    },

    // ---------------------------------------------------------------------
    // Back-office nominee pre-fill (re-activation clients only).
    // Runs only once both async checks are in: getstart (rekyc) and the
    // "already saved in this application?" check. New clients and clients
    // who already saved nominees here are left untouched.
    // ---------------------------------------------------------------------
    tryBoPrefill() {
      if (this.boPrefillAttempted) return;
      if (!this.boGetstartDone || !this.boSavedChecked) return; // wait for both
      this.boPrefillAttempted = true;
      if (!this.boRekyc) return;   // new client -> nothing to do
      if (this.boBlocked) return;  // rejected / re-e-signed pending -> normal flow
      if (this.boHasSaved) return; // client already saved here -> keep theirs
      this.prefillFromBackOffice();
    },
    boIsEmpty(v) {
      if (v === null || v === undefined) return true;
      const s = String(v).trim().toLowerCase();
      return s === "" || s === "null" || s === "none" || s === "undefined" || s === "nan";
    },
    boVal(v) {
      return this.boIsEmpty(v) ? "" : String(v).trim();
    },
    boDob(v) {
      // "YYYY-MM-DD HH:MM:SS" -> "YYYY-MM-DD" (the date-picker's v-model format)
      return this.boIsEmpty(v) ? "" : String(v).trim().slice(0, 10);
    },
    boPercent(v) {
      if (this.boIsEmpty(v)) return "";
      const n = Number(String(v).replace(/[^0-9.]/g, ""));
      return isNaN(n) ? "" : n;
    },
    boMatchRelation(v) {
      if (this.boIsEmpty(v)) return "";
      const norm = (x) => String(x).toLowerCase().replace(/[\s-]/g, "");
      const target = norm(v);
      const match = this.relationitems.find((r) => norm(r) === target);
      return match || ""; // no match -> leave for the client to choose
    },
    prefillFromBackOffice() {
      const mobile = atob(localStorage.getItem("hash"));
      var axiosThis = this;
      this.dataloader = true;
      axios({
        method: "get",
        url: api.api_url + "/bo_nominee_data/" + mobile,
        headers: { "Content-Type": "application/json", "mobile": mobile },
      })
        .then(function (response) {
          const data = response.data || {};
          const rows = Array.isArray(data.nominee_data) ? data.nominee_data : [];
          if (rows.length === 0) { axiosThis.dataloader = false; return; } // "no data found" -> normal empty form
          const row = rows[0];

          const defs = [
            { name: "Nomination_Name", rel: "Nom_Relation", dob: "Nom_DOB", pct: "Share_Percentage", mob: "Nom_Phone", email: "NOM_EMAIL" },
            { name: "Nomination_Name2", rel: "Nom_Relation2", dob: "Nom_DOB2", pct: "Share_Percentage2", mob: "Nom_Phone2", email: "Nom_Email2" },
            { name: "Nomination_Name3", rel: "Nom_Relation3", dob: "Nom_DOB3", pct: "Share_Percentage3", mob: "Nom_Phone3", email: "Nom_Email3" },
          ];

          const built = [];
          for (let i = 0; i < defs.length; i++) {
            const nm = axiosThis.boVal(row[defs[i].name]);
            if (!nm) break; // add a nominee only when its name is non-empty; stop at the first empty name
            const dob = axiosThis.boDob(row[defs[i].dob]);
            built.push({
              name: nm,
              relation: axiosThis.boMatchRelation(row[defs[i].rel]),
              dob: dob,
              percent: axiosThis.boPercent(row[defs[i].pct]),
              mobile: axiosThis.boVal(row[defs[i].mob]),
              email: axiosThis.boVal(row[defs[i].email]),
              age: dob ? (axiosThis.differentDate(dob) >= 18 ? false : true) : false,
            });
          }
          const count = built.length;

          if (count === 0) {
            // No nominee names in back office -> do nothing, leave the normal flow
            // untouched (regardless of NomineeOptOut = Y / N / D / "").
            axiosThis.dataloader = false;
            return;
          }

          axiosThis.boPrefillBuilt = built;
          axiosThis.applyBoPrefill(built);
          axiosThis.dataloader = false;
        })
        .catch(function (error) {
          // 404 / 500 / 502 -> no pre-fill, no error shown to the client.
          console.log("bo_nominee_data pre-fill skipped:", error && error.message);
          axiosThis.dataloader = false;
        });
    },
    // At least one nominee -> fill the form (proof fields are left untouched,
    // addresses are not collected on this screen, guardian stays empty).
    applyBoPrefill(built) {
      const count = built.length;

      // Resolve share percentages. Back office may give some and leave others blank
      // (e.g. nominee 2 = 50 but nominee 1 empty). A single nominee is always 100;
      // otherwise keep the provided values and split the remainder (100 - provided)
      // evenly across the blanks so the total lands on 100.
      if (count === 1) {
        built[0].percent = 100;
      } else {
        let providedSum = 0;
        const blanks = [];
        built.forEach((b, i) => {
          const n = Number(b.percent);
          if (b.percent === "" || b.percent === null || b.percent === undefined || isNaN(n)) {
            blanks.push(i);
          } else {
            providedSum += n;
          }
        });
        if (blanks.length > 0) {
          let remaining = 100 - providedSum;
          if (remaining < 0) remaining = 0;
          const share = remaining / blanks.length;
          blanks.forEach((i) => { built[i].percent = share; });
        }
      }

      this.nom = "Yes";
      this.nomis = 1;
      this.mainnomineeselect = true;
      this.showHypervergeFlow = false;
      this.hypervergeresult = false;

      const apply = (n, src, p) => {
        n[`${p}_name`] = src.name;
        n[`${p}_relation`] = src.relation;
        n[`${p}_dob`] = src.dob;
        n[`${p}_age`] = src.age;
        n[`${p}_mobile`] = src.mobile;
        n[`${p}_email`] = src.email;
        if (src.percent !== "") n[`${p}_percent`] = src.percent;
      };
      apply(this.nominee1, built[0], "n1");
      if (count >= 2) apply(this.nominee2, built[1], "n2");
      if (count >= 3) apply(this.nominee3, built[2], "n3");

      // Show the right number of nominee panels + relax the per-field % cap like the tab buttons do.
      if (count === 1) {
        this.activetab = "";
      } else if (count === 2) {
        this.activetab = "tab2";
        this.n1_permax = 99; this.n2_permax = 99;
      } else {
        this.activetab = "tab3";
        this.n1_permax = 98; this.n2_permax = 98; this.n3_permax = 98;
      }
      this.panel = 0;
      this.boPrefillNotice = "filled";
    },

    n1save() {
      this.n1_menu = false;
      this.$refs.n1_menu.save(this.nominee1.n1_dob);
      this.nominee1.n1_age = this.differentDate(this.nominee1.n1_dob) >= 18 ? false : true;
      if (!this.nominee1.n1_age) {
        this.nominee1.g1_name = "";
        this.nominee1.g1_dob = "";
        this.nominee1.g1_relation = "";
        this.nominee1.g1_proof = null;
        this.nominee1.g1_addrCB = true;
        this.nominee1.g1_addr = "";
        this.nominee1.g1_city = "";
        this.nominee1.g1_state = "";
        this.nominee1.g1_country = "";
        this.nominee1.g1_pincode = "";
      }
      this.goAdds();
    },
    n2save() {
      this.n2_menu = false;
      this.$refs.n2_menu.save(this.nominee2.n2_dob);
      this.nominee2.n2_age = this.differentDate(this.nominee2.n2_dob) >= 18 ? false : true;
      if (!this.nominee2.n2_age) {
        this.nominee2.g2_name = "";
        this.nominee2.g2_dob = "";
        this.nominee2.g2_relation = "";
        this.nominee2.g2_proof = null;
        this.nominee2.g2_addrCB = true;
        this.nominee2.g2_addr = "";
        this.nominee2.g2_city = "";
        this.nominee2.g2_state = "";
        this.nominee2.g2_country = "";
        this.nominee2.g2_pincode = "";
      }
      this.gtAdds();
    },
    n3save() {
      this.n3_menu = false;
      this.$refs.n3_menu.save(this.nominee3.n3_dob);
      this.nominee3.n3_age = this.differentDate(this.nominee3.n3_dob) >= 18 ? false : true;
      if (!this.nominee3.n3_age) {
        this.nominee3.g3_name = "";
        this.nominee3.g3_dob = "";
        this.nominee3.g3_relation = "";
        this.nominee3.g3_proof = null;
        this.nominee3.g3_addrCB = true;
        this.nominee3.g3_addr = "";
        this.nominee3.g3_city = "";
        this.nominee3.g3_state = "";
        this.nominee3.g3_country = "";
        this.nominee3.g3_pincode = "";
      }
      this.grAdds();
    },
    g1save() {
      this.g1_menu = false;
      this.$refs.g1_menu.save(this.nominee1.g1_dob);
    },
    g2save() {
      this.g2_menu = false;
      this.$refs.g2_menu.save(this.nominee2.g2_dob);
    },
    g3save() {
      this.g3_menu = false;
      this.$refs.g3_menu.save(this.nominee3.g3_dob);
    },
    setNominee() {
      var norm = (v) => (v || "").toString().replace(/\s+/g, "").toLowerCase();
      var normDob = (v) => {
        if (!v) return "";
        var s = v.toString().trim();
        var parts = s.split(/[-/]/);
        if (parts.length !== 3) return s;
        if (parts[0].length === 4) return parts[0] + "-" + parts[1].padStart(2, "0") + "-" + parts[2].padStart(2, "0");
        return parts[2] + "-" + parts[1].padStart(2, "0") + "-" + parts[0].padStart(2, "0");
      };
      var normMobile = (v) => (v || "").toString().replace(/\D/g, "");
      var cName_pre = norm(this.clientName);
      var cAadName_pre = norm(this.clientAadhaarName);
      var cDob_pre = normDob(this.clientDob);
      var cEmail_pre = norm(this.clientEmail);
      var cPan_pre = norm(this.clientPan);
      var cAad4_pre = (this.clientAadhaarLast4 || "").toString().trim();
      var cMobile_pre = (this.clientMobile || "").toString().replace(/\D/g, "");
      // Only validate the nominees that are actually active/saved for the current
      // tab. nominee2/3 may still hold pre-filled data (e.g. a back-office email that
      // matches the client's) while the user is in a single-nominee view, and those
      // are not saved -- so checking them would raise a false "cannot be the same".
      var preNoms = [
        {name: this.nominee1.n1_name, dob: this.nominee1.n1_dob, email: this.nominee1.n1_email, mobile: this.nominee1.n1_mobile, proofType: this.nominee1.n1_proofType, proof: this.nominee1.n1_pan, gName: this.nominee1.g1_name, gDob: this.nominee1.g1_dob},
      ];
      if (this.activetab == "tab2" || this.activetab == "tab3") {
        preNoms.push({name: this.nominee2.n2_name, dob: this.nominee2.n2_dob, email: this.nominee2.n2_email, mobile: this.nominee2.n2_mobile, proofType: this.nominee2.n2_proofType, proof: this.nominee2.n2_pan, gName: this.nominee2.g2_name, gDob: this.nominee2.g2_dob});
      }
      if (this.activetab == "tab3") {
        preNoms.push({name: this.nominee3.n3_name, dob: this.nominee3.n3_dob, email: this.nominee3.n3_email, mobile: this.nominee3.n3_mobile, proofType: this.nominee3.n3_proofType, proof: this.nominee3.n3_pan, gName: this.nominee3.g3_name, gDob: this.nominee3.g3_dob});
      }
      (this.additionalNominees || []).forEach((nx) => {
        preNoms.push({name: nx.name, dob: nx.dob, email: nx.email, mobile: nx.mobile, proofType: nx.proofType, proof: nx.proof, gName: nx.g_name, gDob: nx.g_dob});
      });
      for (var k = 0; k < preNoms.length; k++) {
        var pn = preNoms[k];
        if (!pn.name && !pn.dob && !pn.email && !pn.proof && !pn.mobile && !pn.gName && !pn.gDob) continue;
        if (cName_pre && pn.name && norm(pn.name) === cName_pre) { this.$emit("snack", 0, "Client Name and Nominee Name cannot be the same."); return; }
        if (cDob_pre && pn.dob && normDob(pn.dob) === cDob_pre) { this.$emit("snack", 0, "Client DOB and Nominee DOB cannot be the same."); return; }
        if (cEmail_pre && pn.email && norm(pn.email) === cEmail_pre) { this.$emit("snack", 0, "Client Email and Nominee Email cannot be the same."); return; }
        if (cMobile_pre && pn.mobile && normMobile(pn.mobile) === cMobile_pre) { this.$emit("snack", 0, "Client Mobile and Nominee Mobile cannot be the same."); return; }
        if (pn.proof && pn.proofType === "PAN" && cPan_pre && norm(pn.proof) === cPan_pre) { this.$emit("snack", 0, "Client PAN and Nominee PAN cannot be the same."); return; }
        if (pn.proof && pn.proofType === "AADHAR" && cAad4_pre && pn.proof.toString().trim().slice(-4) === cAad4_pre) { this.$emit("snack", 0, "Client Aadhaar and Nominee Aadhaar cannot be the same."); return; }
        if (cName_pre && pn.gName && norm(pn.gName) === cName_pre) { this.$emit("snack", 0, "Client Name and Guardian Name cannot be the same."); return; }
        if (cAadName_pre && pn.name && norm(pn.name) === cAadName_pre) { this.$emit("snack", 0, "Aadhaar Name and Nominee Name cannot be the same."); return; }
        if (cAadName_pre && pn.gName && norm(pn.gName) === cAadName_pre) { this.$emit("snack", 0, "Aadhaar Name and Guardian Name cannot be the same."); return; }
        if (cDob_pre && pn.gDob && normDob(pn.gDob) === cDob_pre) { this.$emit("snack", 0, "Client DOB and Guardian DOB cannot be the same."); return; }
        if (pn.name && pn.gName && norm(pn.name) && norm(pn.gName) && norm(pn.name) === norm(pn.gName)) { this.$emit("snack", 0, "Nominee Name and Guardian Name cannot be the same."); return; }
        if (pn.dob && pn.gDob && normDob(pn.dob) && normDob(pn.gDob) && normDob(pn.dob) === normDob(pn.gDob)) { this.$emit("snack", 0, "Nominee DOB and Guardian DOB cannot be the same."); return; }
      }
      if (atob(localStorage.getItem("hash")) && !this.$v.nominee1.$invalid) {
        this.cardloader = true;
        this.$v.$reset();

        // Ensure address fields are populated if "Same as my address" is checked
        if (this.nominee1.n1_addrCB) this.noAdds();
        if (this.nominee1.g1_addrCB) this.goAdds();
        if (this.nominee2.n2_addrCB) this.ntAdds();
        if (this.nominee2.g2_addrCB) this.gtAdds();
        if (this.nominee3.n3_addrCB) this.nrAdds();
        if (this.nominee3.g3_addrCB) this.grAdds();

        var axiosThis = this;
        let one = axiosThis.activetab == "tab3" || axiosThis.activetab == "tab2" || axiosThis.activetab == "" ? axiosThis.nominee1 : axiosThis.nomi1;
        let two = axiosThis.activetab == "tab3" || axiosThis.activetab == "tab2" ? axiosThis.nominee2 : axiosThis.nomi2;
        let tre = axiosThis.activetab == "tab3" ? axiosThis.nominee3 : axiosThis.nomi3;

        let totalPercent = Number(one.n1_percent) + Number(two.n2_percent) + Number(tre.n3_percent);
        this.additionalNominees.forEach(n => {
          totalPercent += Number(n.percent);
        });

        if (totalPercent == 100) {
          one.n1_percent = `${one.n1_percent}`;
          two.n2_percent = `${two.n2_percent > 0 ? two.n2_percent : ""}`;
          tre.n3_percent = `${tre.n3_percent > 0 ? tre.n3_percent : ""}`;
          if (one.n1_age == false) {
            one = { ...one, ...axiosThis.gud.g1 };
          }
          if (two.n2_age == false) {
            two = { ...two, ...axiosThis.gud.g2 };
          }
          if (tre.n3_age == false) {
            tre = { ...tre, ...axiosThis.gud.g3 };
          }

          one.n1_sameasadress = one.n1_addrCB ? 'yes' : 'no';
          two.n2_sameasadress = two.n2_addrCB ? 'yes' : 'no';
          tre.n3_sameasadress = tre.n3_addrCB ? 'yes' : 'no';

          // Statement print preference is a single choice shared by all nominees.
          one.n1_hold_print = axiosThis.holdPrint;
          two.n2_hold_print = (axiosThis.activetab == 'tab2' || axiosThis.activetab == 'tab3') ? axiosThis.holdPrint : "";
          tre.n3_hold_print = (axiosThis.activetab == 'tab3') ? axiosThis.holdPrint : "";

          // Helper to strip URL prefix for backend storage
          const sanitizeProof = (proof) => {
            if (typeof proof === 'string' && proof.includes("filsend?path=")) {
               return proof.split("filsend?path=")[1];
            }
            return proof; 
          };

          let oneObj = { ...one };
          if(oneObj.g1_proof) oneObj.g1_proof = sanitizeProof(oneObj.g1_proof);
          
          let twoObj = { ...two };
          if(twoObj.g2_proof) twoObj.g2_proof = sanitizeProof(twoObj.g2_proof);

          let treObj = { ...tre };
          if(treObj.g3_proof) treObj.g3_proof = sanitizeProof(treObj.g3_proof);

          let allNominees = [oneObj, twoObj, treObj];

          this.additionalNominees.forEach((n, index) => {
            let i = index + 4;
            // Populate address if "Same as my address" is checked
            if (n.addrCB) {
              n.addr = axiosThis.sameaddress.address;
              n.city = axiosThis.sameaddress.city;
              n.state = axiosThis.sameaddress.state;
              n.country = axiosThis.sameaddress.country;
              n.pincode = axiosThis.sameaddress.pincode;
            }

            // Populate guardian address if "Same as my address" is checked (for minors)
            if (n.age && n.g_addrCB) {
              n.g_addr = axiosThis.sameaddress.address;
              n.g_city = axiosThis.sameaddress.city;
              n.g_state = axiosThis.sameaddress.state;
              n.g_country = axiosThis.sameaddress.country;
              n.g_pincode = axiosThis.sameaddress.pincode;
            }

            let mapped = {
              [`n${i}_name`]: n.name,
              [`n${i}_email`]: n.email,
              [`n${i}_mobile`]: n.mobile,
              [`n${i}_pan`]: n.proof,
              [`n${i}_dob`]: n.dob,
              [`n${i}_relation`]: n.relation,
              [`n${i}_percent`]: `${n.percent}`,
              [`n${i}_addrCB`]: n.addrCB,
              [`n${i}_sameasadress`]: n.addrCB ? 'yes' : 'no',
              [`n${i}_addr`]: n.addr,
              [`n${i}_addr2`]: "",
              [`n${i}_city`]: n.city,
              [`n${i}_state`]: n.state,
              [`n${i}_country`]: n.country,
              [`n${i}_pincode`]: n.pincode,
              [`n${i}_proofType`]: n.proofType,
              [`n${i}_hold_print`]: axiosThis.holdPrint,
              [`n${i}_age`]: n.age
            };

            // Always map guardian details, they will be empty/irrelevant for adults but needed for minors
            mapped[`g${i}_name`] = n.g_name || "";
            mapped[`g${i}_dob`] = n.g_dob || "";
            mapped[`g${i}_mobile`] = "";
            mapped[`g${i}_relation`] = n.g_relation || "";
            mapped[`g${i}_addrCB`] = n.g_addrCB;
            mapped[`g${i}_addr`] = n.g_addr || "";
            mapped[`g${i}_city`] = n.g_city || "";
            mapped[`g${i}_state`] = n.g_state || "";
            mapped[`g${i}_country`] = n.g_country || "";
            mapped[`g${i}_pincode`] = n.g_pincode || "";
            mapped[`g${i}_proofType`] = n.g_proofType || "";
            mapped[`g${i}_pan`] = n.g_pan || "";
            mapped[`g${i}_proof`] = sanitizeProof(n.g_proof || "");

            allNominees.push(mapped);
          });


          // Ensure we always send exactly 10 nominees (pad with properly structured empty nominees if needed)
          for (let i = allNominees.length + 1; i <= 10; i++) {
            allNominees.push({
              [`n${i}_name`]: "",
              [`n${i}_email`]: "",
              [`n${i}_mobile`]: "",
              [`n${i}_pan`]: "",
              [`n${i}_dob`]: "",
              [`n${i}_age`]: "",
              [`n${i}_relation`]: "",
              [`n${i}_percent`]: "",
              [`n${i}_addrCB`]: "",
              [`n${i}_sameasadress`]: "",
              [`n${i}_addr`]: "",
              [`n${i}_addr2`]: "",
              [`n${i}_city`]: "",
              [`n${i}_state`]: "",
              [`n${i}_country`]: "",
              [`n${i}_pincode`]: "",
              [`n${i}_proofType`]: "",
              [`n${i}_proof`]: "",
              [`n${i}_hold_print`]: "",
              [`g${i}_name`]: "",
              [`g${i}_email`]: "",
              [`g${i}_mobile`]: "",
              [`g${i}_dob`]: "",
              [`g${i}_relation`]: "",
              [`g${i}_addrCB`]: "",
              [`g${i}_addr`]: "",
              [`g${i}_city`]: "",
              [`g${i}_state`]: "",
              [`g${i}_country`]: "",
              [`g${i}_pincode`]: "",
              [`g${i}_proofType`]: "",
              [`g${i}_pan`]: ""
            });
          }

          let guardianProofs = [];

          // Helper to get proof or empty string
          const getProof = (n, key) => (n && n[key]) ? n[key] : "";

          // 1. Nominee 1`
          guardianProofs.push(getProof(one, 'g1_proof'));
          // 2. Nominee 2
          guardianProofs.push(getProof(two, 'g2_proof'));
          // 3. Nominee 3
          guardianProofs.push(getProof(tre, 'g3_proof'));

          // 4-10. Additional Nominees
          this.additionalNominees.forEach(n => {
            guardianProofs.push((n.g_proof) ? n.g_proof : "");
          });

          // Nominee/guardian address is no longer collected on this screen — always send these fields empty.
          const blankAddressKeys = /^[ng]\d+_(addr|addr2|city|state|country|pincode|addrCB|sameasadress)$/;
          allNominees = allNominees.map((nom) => {
            const cleaned = { ...nom };
            Object.keys(cleaned).forEach((key) => {
              if (blankAddressKeys.test(key)) cleaned[key] = "";
            });
            return cleaned;
          });

          let formData = new FormData();
          formData.append('objects', JSON.stringify(allNominees));
          formData.append('mobile', atob(localStorage.getItem("hash")));

          let guardianIndex = 0;
          guardianProofs.forEach((file, index) => {
            const nomineeNumber = index + 1;
            // Case 1: New file upload. Only send if not empty (size > 0).
            if (file && typeof file === "object" && file.size > 0) {
              formData.append(`guardian_proof`, file);
              formData.append(`guardian_no`, nomineeNumber);
              formData.append(`guardion_no_prctype`, "new");
              guardianIndex++;
            }
            // Case 2: Existing proof path (String). Only send if not empty.
            // else if (typeof file === "string" && file.trim().length > 0) {
            //   formData.append(`guardian_no${nomineeNumber}`, nomineeNumber);
            //   formData.append(`guardion_no${nomineeNumber}_prctype`, "old");
            //   guardianIndex++;
            // }
          });
          formData.append("guardian_count", guardianIndex);

          var config = {
            method: "post",
            url: api.api_url + "/signupGetNomineeDetails",
            headers: { "Content-Type": "multipart/form-data", "mobile": atob(localStorage.getItem("hash")) },
            data: formData,
          };

          axios(config)
            .then(function (response) {
              if (response.data.data == "All Nominee details updated.") {
                    axiosThis.hypervergetstainnominee()
                    axiosThis.$v.$reset();
                    axiosThis.toNext();
                    axiosThis.cardloader = false;
              } else {
                axiosThis.$emit("snack", 0, response.data);
                axiosThis.cardloader = false;
              }
            })
            .catch(function (error) {
              console.log(error);
              axiosThis.$emit("snack", 0, error);
              axiosThis.cardloader = false;
            });


        } else {
          this.cardloader = false;
          axiosThis.$emit("snack", 0, "The sum of the nominee percentages must be equal to 100.");
        }
      }
    },
    viewnomineeprofftype(prooftype) {
      if (prooftype == 'PAN') {
        return "PAN Number"
      } else if (prooftype == 'AADHAR') {
        return "Aadhaar number(last 4 digits)"
      } else if (prooftype == 'PROOF OF IDENTITY') {
        return "Driving Licence Number"
      } else if (prooftype == 'PASSPORT') {
        return "Passport Number"
      }
    },
    dynamicPerChange() {
      let totalDynamic = this.additionalNominees.reduce((sum, n) => sum + Number(n.percent), 0);
      let remaining = 100 - totalDynamic;

      if (remaining < 0) remaining = 0;

      let n1 = Number(this.nominee1.n1_percent) || 0;
      let n2 = Number(this.nominee2.n2_percent) || 0;
      let n3 = Number(this.nominee3.n3_percent) || 0;

      let activeCount = 1;
      let currentStaticTotal = n1;

      if (this.activetab == 'tab2') {
        activeCount = 2;
        currentStaticTotal = n1 + n2;
      } else if (this.activetab == 'tab3') {
        activeCount = 3;
        currentStaticTotal = n1 + n2 + n3;
      }

      if (currentStaticTotal === 0) {
        let share = remaining / activeCount;
        this.nominee1.n1_percent = parseFloat(share.toFixed(2));
        if (activeCount >= 2) this.nominee2.n2_percent = parseFloat(share.toFixed(2));
        if (activeCount >= 3) this.nominee3.n3_percent = parseFloat(share.toFixed(2));
      } else {
        let scale = remaining / currentStaticTotal;
        this.nominee1.n1_percent = parseFloat((n1 * scale).toFixed(2));
        if (activeCount >= 2) this.nominee2.n2_percent = parseFloat((n2 * scale).toFixed(2));
        if (activeCount >= 3) this.nominee3.n3_percent = parseFloat((n3 * scale).toFixed(2));
      }
    },
    distributePercentages() {
      this.percentManualEdit = { n1: false, n2: false, n3: false };
      let totalNominees = 1;
      if (this.activetab == 'tab2') totalNominees = 2;
      if (this.activetab == 'tab3') totalNominees = 3;
      totalNominees += this.additionalNominees.length;

      console.log(`Distributing percentages for ${totalNominees} nominees (Tab: ${this.activetab}, Dynamic: ${this.additionalNominees.length})`);

      const distributions = {
        1: [100],
        2: [50, 50],
        3: [40, 30, 30],
        4: [35, 25, 20, 20],
        5: [30, 20, 20, 15, 15],
        6: [28, 18, 18, 14, 12, 10],
        7: [25, 15, 15, 15, 10, 10, 10],
        8: [22, 12, 12, 12, 12, 10, 10, 10],
        9: [20, 12, 12, 12, 10, 10, 10, 8, 6],
        10: [20, 10, 10, 10, 10, 10, 10, 10, 5, 5]
      };

      const percentages = distributions[totalNominees] || [];

      if (percentages.length > 0) {
        // Use $set or direct assignment, but ensure it triggers updates
        this.nominee1.n1_percent = percentages[0];
        if (percentages.length > 1) this.nominee2.n2_percent = percentages[1];
        if (percentages.length > 2) this.nominee3.n3_percent = percentages[2];

        this.additionalNominees.forEach((nominee, index) => {
          if (percentages.length > index + 3) {
            // Ensure reactivity for dynamic nominees
            this.$set(nominee, 'percent', percentages[index + 3]);
          }
        });
        console.log("Percentages applied:", percentages);
      }
    },
    addNominee() {
      if (this.additionalNominees.length + 3 < 10) {
        let newNominee = {
          name: "",
          percent: "",
          dob: "",
          relation: "",
          proofType: "",
          proof: "",
          mobile: "",
          email: "",
          hold_print: "",
          addrCB: true,
          addr: this.sameaddress.address,
          city: this.sameaddress.city,
          state: this.sameaddress.state,
          country: this.sameaddress.country,
          pincode: this.sameaddress.pincode,
          age: false,
          g_name: "",
          g_dob: "",
          g_relation: "",
          g_addrCB: true,
          g_addr: "",
          g_city: "",
          g_state: "",
          g_country: "",
          g_pincode: "",
          g_proofType: "",
          g_pan: "",
          g_proof: null,
          menu_dob: false,
          menu_g_dob: false,
          touched: {}
        };
        this.additionalNominees.push(newNominee);
        this.panel = this.additionalNominees.length + 2;
        this.distributePercentages();
      }
    },
    removeNominee(index) {
      this.additionalNominees.splice(index, 1);
      if (this.panel > this.additionalNominees.length + 2) {
        this.panel = this.additionalNominees.length + 2;
      }
      this.distributePercentages();
    },
    getOrdinal(n) {
      var s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
    isNomineeValid(index) {
      let n = this.additionalNominees[index];
      return n.name && n.percent && n.dob && n.relation && n.proofType && n.proof && n.mobile && n.email;
    },
    onHoldPrintCheck(value, checked) {
      this.holdPrint = checked ? value : "";
      this.$v.holdPrint.$touch();
    },
    saveDynamicGDob(index) {
      this.additionalNominees[index].menu_g_dob = false;
    },
    dynamicNomineeAddress(index) {
      let n = this.additionalNominees[index];
      if (n.addrCB) {
        n.addr = this.sameaddress.address;
        n.city = this.sameaddress.city;
        n.state = this.sameaddress.state;
        n.country = this.sameaddress.country;
        n.pincode = this.sameaddress.pincode;
      } else {
        n.addr = "";
        n.city = "";
        n.state = "";
        n.country = "";
        n.pincode = "";
      }
    },
    dynamicGuardianAddress(index) {
      let n = this.additionalNominees[index];
      if (n.g_addrCB) {
        n.g_addr = this.sameaddress.address;
        n.g_city = this.sameaddress.city;
        n.g_state = this.sameaddress.state;
        n.g_country = this.sameaddress.country;
        n.g_pincode = this.sameaddress.pincode;
      } else {
        n.g_addr = "";
        n.g_city = "";
        n.g_state = "";
        n.g_country = "";
        n.g_pincode = "";
      }
    },
    getDynamicError(index, field) {
      let n = this.additionalNominees[index];
      if (!n.touched || !n.touched[field]) return [];

      let errors = [];
      if (field === 'name' && !n.name) errors.push("Mandatory Field");
      if (field === 'percent' && !n.percent) errors.push("Mandatory Field");
      if (field === 'dob' && !n.dob) errors.push("Mandatory Field");
      if (field === 'relation' && !n.relation) errors.push("Mandatory Field");
      if (field === 'proofType' && !n.proofType) errors.push("Mandatory Field");
      if (field === 'proof') {
        if (!n.proof) {
          errors.push("Mandatory Field");
        } else {
          if (n.proofType === 'PAN' && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(n.proof)) {
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
          } else if (n.proofType === 'AADHAR' && (!/^\d{4}$/.test(n.proof) || !/[1-9]/.test(n.proof))) {
            errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
          } else if (n.proofType === 'PROOF OF IDENTITY' && !/^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/.test(n.proof)) {
            errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
          } else if (n.proofType === 'PASSPORT' && !/^[A-Z][0-9]{7}$/.test(n.proof)) {
            errors.push("Invalid Passport format (e.g. A1234567)");
          }
        }
      }
      if (field === 'mobile' && !n.mobile) errors.push("Mandatory Field");
      if (field === 'email' && !n.email) errors.push("Mandatory Field");

      // Address validation
      if (!n.addrCB) {
        if (field === 'addr' && !n.addr) errors.push("Mandatory Field");
        if (field === 'city' && !n.city) errors.push("Mandatory Field");
        if (field === 'state' && !n.state) errors.push("Mandatory Field");
        if (field === 'country' && !n.country) errors.push("Mandatory Field");
        if (field === 'pincode' && !n.pincode) errors.push("Mandatory Field");
      }

      // Guardian validation
      if (n.age) {
        if (field === 'g_name' && !n.g_name) errors.push("Mandatory Field");
        if (field === 'g_dob' && !n.g_dob) errors.push("Mandatory Field");
        if (field === 'g_relation' && !n.g_relation) errors.push("Mandatory Field");
        if (field === 'g_proofType' && !n.g_proofType) errors.push("Mandatory Field");
        if (field === 'g_pan') {
          if (!n.g_pan) {
            errors.push("Mandatory Field");
          } else {
            if (n.g_proofType === 'PAN' && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(n.g_pan)) {
              errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            } else if (n.g_proofType === 'AADHAR' && (!/^\d{4}$/.test(n.g_pan) || !/[1-9]/.test(n.g_pan))) {
              errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
            } else if (n.g_proofType === 'PROOF OF IDENTITY' && !/^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/.test(n.g_pan)) {
              errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
            } else if (n.g_proofType === 'PASSPORT' && !/^[A-Z][0-9]{7}$/.test(n.g_pan)) {
              errors.push("Invalid Passport format (e.g. A1234567)");
            }
          }
        }

        if (!n.g_addrCB) {
          if (field === 'g_addr' && !n.g_addr) errors.push("Mandatory Field");
          if (field === 'g_city' && !n.g_city) errors.push("Mandatory Field");
          if (field === 'g_state' && !n.g_state) errors.push("Mandatory Field");
          if (field === 'g_country' && !n.g_country) errors.push("Mandatory Field");
          if (field === 'g_pincode' && !n.g_pincode) errors.push("Mandatory Field");
        }
        if (field === 'g_proof' && n.g_relation === 'Court-Appointed Guardian') {
          if (!n.g_proof) {
            errors.push("Mandatory Field");
          } else if (typeof n.g_proof !== 'string') {
            const allowed = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
            if (!allowed.includes(n.g_proof.type)) errors.push("Only PDF, JPG, PNG files are allowed");
            if (n.g_proof.size > 5 * 1024 * 1024) errors.push("File size must be less than 5MB");
          }
        }
      }
      return errors;
    },
    touchDynamicField(index, field) {
      let n = this.additionalNominees[index];
      if (!n.touched) this.$set(n, 'touched', {});
      this.$set(n.touched, field, true);
    },
    saveDynamicDob(index) {
      this.additionalNominees[index].menu_dob = false;
      this.additionalNominees[index].age = this.differentDate(this.additionalNominees[index].dob) >= 18 ? false : true;
    },
    async fetchDynamicPincodeData(index) {
      let nominee = this.additionalNominees[index];
      if (nominee.pincode && nominee.pincode.length === 6) {
        try {
          const response = await axios.get(`https://api.postalpincode.in/pincode/${nominee.pincode}`);
          if (response.data && response.data[0].Status === 'Success' && response.data[0].PostOffice && response.data[0].PostOffice.length > 0) {
            let postOffices = response.data[0].PostOffice;
            this.$set(nominee, 'state', postOffices[0].State);
            this.$set(nominee, 'country', postOffices[0].Country);
            if (postOffices.length > 1) {
              this.$set(nominee, 'cityOptions', postOffices.map(po => po.Name));
              this.$set(nominee, 'city', '');
            } else {
              this.$set(nominee, 'cityOptions', []);
              this.$set(nominee, 'city', postOffices[0].Name);
            }
          } else {
            this.$set(nominee, 'cityOptions', []);
            this.$emit("snack", 0, "Invalid pincode");
          }
        } catch (error) {
          console.error("Error fetching pincode data:", error);
          this.$emit("snack", 0, "Failed to fetch pincode data");
        }
      }
    },
    async fetchDynamicGuardianPincodeData(index) {
      let nominee = this.additionalNominees[index];
      if (nominee.g_pincode && nominee.g_pincode.length === 6) {
        try {
          const response = await axios.get(`https://api.postalpincode.in/pincode/${nominee.g_pincode}`);
          if (response.data && response.data[0].Status === 'Success' && response.data[0].PostOffice && response.data[0].PostOffice.length > 0) {
            let postOffices = response.data[0].PostOffice;
            this.$set(nominee, 'g_state', postOffices[0].State);
            this.$set(nominee, 'g_country', postOffices[0].Country);
            if (postOffices.length > 1) {
              this.$set(nominee, 'gCityOptions', postOffices.map(po => po.Name));
              this.$set(nominee, 'g_city', '');
            } else {
              this.$set(nominee, 'gCityOptions', []);
              this.$set(nominee, 'g_city', postOffices[0].Name);
            }
          } else {
            this.$set(nominee, 'gCityOptions', []);
            this.$emit("snack", 0, "Invalid pincode");
          }
        } catch (error) {
          console.error("Error fetching guardian pincode data:", error);
          this.$emit("snack", 0, "Failed to fetch pincode data");
        }
      }
    },


    getNomineedata() {
      this.dataloader = true;

      var axiosThis = this;
      var formData = new FormData();
      formData.append('mobile', atob(localStorage.getItem("hash")));
      var config = {
        method: "post",
        url: api.api_url + "/signupGetNomineeDetails",
        headers: { "Content-Type": "multipart/form-data", "mobile": atob(localStorage.getItem("hash")) },
        data: formData,
      };
      axios(config)
        .then(function (response) {
          var data = response.data;
          axiosThis.holdPrint = (data["nominee1"] && data["nominee1"]["Nom1_hold_print"]) || (data["nominee2"] && data["nominee2"]["Nom2_hold_print"]) || (data["nominee3"] && data["nominee3"]["Nom3_hold_print"]) || "";
          if (data["nominee1"]) {
            axiosThis.nominee1.n1_name = data["nominee1"]["Nom1_name"];
            axiosThis.nominee1.n1_dob = data["nominee1"]["Nom1_DOB"];
            axiosThis.nominee1.n1_relation = data["nominee1"]["Nom1_relation"];
            if (Object.prototype.hasOwnProperty.call(data["nominee1"], "Nom1_percent_feild1")) {
              axiosThis.nominee1.n1_percent = data["nominee1"]["Nom1_percent_feild1"];
            }
            axiosThis.nominee1.n1_email = data["nominee1"]["Nom1_email"];
            axiosThis.nominee1.n1_mobile = data["nominee1"]["Nom1_mobile"];
            axiosThis.nominee1.n1_addr = data["nominee1"]["Nom1_address1"];
            axiosThis.nominee1.n1_city = data["nominee1"]["Nom1_city"];
            axiosThis.nominee1.n1_state = data["nominee1"]["Nom1_state"];
            axiosThis.nominee1.n1_country = data["nominee1"]["Nom1_country"];
            axiosThis.nominee1.n1_pincode = data["nominee1"]["Nom1_pincode"];
            axiosThis.nominee1.n1_proofType = data["nominee1"]["nom1_doc_type"];
            axiosThis.nominee1.n1_pan = data["nominee1"]["Nom1_PAN"];
            axiosThis.nominee1.n1_hold_print = data["nominee1"]["Nom1_hold_print"] || "";
            axiosThis.nominee1.n1_addrCB = data["nominee1"]["Nom1_addrCB"] == "True" ? true : false;
            axiosThis.nominee1.n1_age = data["nominee1"]["Nom1_age"] == "True" ? true : false;
            axiosThis.activetab = Number(axiosThis.nominee1.n1_percent) < 100 ? "" : ""; // Adjusted logic based on percent
            axiosThis.changenominee = Number(axiosThis.nominee1.n1_percent) < 100 ? true : false;

            if (data["guardian1"]) {
              axiosThis.nominee1.g1_name = data["guardian1"]["Guardian_name"] ? data["guardian1"]["Guardian_name"] : "";
              axiosThis.nominee1.g1_dob = data["guardian1"]["Guardian_dob"] ? data["guardian1"]["Guardian_dob"] : "";
              axiosThis.nominee1.g1_relation = data["guardian1"]["Guardian_relation"] ? data["guardian1"]["Guardian_relation"] : "";
              axiosThis.nominee1.g1_addrCB = data["guardian1"]["Guardian_addrCB"] == "True" ? true : false;
              axiosThis.nominee1.g1_addr = data["guardian1"]["Guardian_address"] ? data["guardian1"]["Guardian_address"] : "";
              axiosThis.nominee1.g1_city = data["guardian1"]["Guardian_city"] ? data["guardian1"]["Guardian_city"] : "";
              axiosThis.nominee1.g1_state = data["guardian1"]["Guardian_state"] ? data["guardian1"]["Guardian_state"] : "";
              axiosThis.nominee1.g1_country = data["guardian1"]["Guardian_country"] ? data["guardian1"]["Guardian_country"] : "";
              axiosThis.nominee1.g1_pincode = data["guardian1"]["Guardian_pincode"] ? data["guardian1"]["Guardian_pincode"] : "";
              axiosThis.nominee1.g1_proofType = data["guardian1"]["Guardian_doc_type"] ? data["guardian1"]["Guardian_doc_type"] : "AADHAR";
              axiosThis.nominee1.g1_pan = data["guardian1"]["Guardian_PAN"] ? data["guardian1"]["Guardian_PAN"] : "";
              
              if (data["guardian1"]["Guardian_proof"]) {
                let proofPath = data["guardian1"]["Guardian_proof"];
                if (!proofPath.startsWith("http")) {
                   axiosThis.nominee1.g1_proof = api.api_url+ `/filsend?path=${proofPath}`;
                } else {
                   axiosThis.nominee1.g1_proof = proofPath;
                }
              }
            }
          }

          if (data["nominee2"]) {
            axiosThis.nominee2.n2_name = data["nominee2"]["Nom2_name"];
            axiosThis.nominee2.n2_dob = data["nominee2"]["Nom2_DOB"];
            axiosThis.nominee2.n2_relation = data["nominee2"]["Nom2_relation"];
            if (Object.prototype.hasOwnProperty.call(data["nominee2"], "Nom2_percent_feild1")) {
              axiosThis.nominee2.n2_percent = data["nominee2"]["Nom2_percent_feild1"];
            }
            axiosThis.nominee2.n2_email = data["nominee2"]["Nom2_email"];
            axiosThis.nominee2.n2_mobile = data["nominee2"]["Nom2_mobile"];
            axiosThis.nominee2.n2_addr = data["nominee2"]["Nom2_address1"];
            axiosThis.nominee2.n2_city = data["nominee2"]["Nom2_city"];
            axiosThis.nominee2.n2_state = data["nominee2"]["Nom2_state"];
            axiosThis.nominee2.n2_country = data["nominee2"]["Nom2_country"];
            axiosThis.nominee2.n2_pincode = data["nominee2"]["Nom2_pincode"];
            axiosThis.nominee2.n2_proofType = data["nominee2"]["nom2_doc_type"];
            axiosThis.nominee2.n2_pan = data["nominee2"]["Nom2_PAN"];
            axiosThis.nominee2.n2_hold_print = data["nominee2"]["Nom2_hold_print"] || "";
            axiosThis.nominee2.n2_addrCB = data["nominee2"]["Nom2_addrCB"] == "True" ? true : false;
            axiosThis.nominee2.n2_age = data["nominee2"]["Nom2_age"] == "True" ? true : false;
            axiosThis.activetab = Number(axiosThis.nominee2.n2_percent) > 0 ? "tab2" : axiosThis.activetab;

            if (data["guardian2"]) {
              axiosThis.nominee2.g2_name = data["guardian2"]["Guardian_name2"] ? data["guardian2"]["Guardian_name2"] : "";
              axiosThis.nominee2.g2_dob = data["guardian2"]["Guardian_dob2"] ? data["guardian2"]["Guardian_dob2"] : "";
              axiosThis.nominee2.g2_relation = data["guardian2"]["Guardian_relation2"] ? data["guardian2"]["Guardian_relation2"] : "";
              axiosThis.nominee2.g2_addrCB = data["guardian2"]["Guardian_addrCB2"] == "True" ? true : false;
              axiosThis.nominee2.g2_addr = data["guardian2"]["Guardian_address2"] ? data["guardian2"]["Guardian_address2"] : "";
              axiosThis.nominee2.g2_city = data["guardian2"]["Guardian_city2"] ? data["guardian2"]["Guardian_city2"] : "";
              axiosThis.nominee2.g2_state = data["guardian2"]["Guardian_state2"] ? data["guardian2"]["Guardian_state2"] : "";
              axiosThis.nominee2.g2_country = data["guardian2"]["Guardian_country2"] ? data["guardian2"]["Guardian_country2"] : "";
              axiosThis.nominee2.g2_pincode = data["guardian2"]["Guardian_pincode2"] ? data["guardian2"]["Guardian_pincode2"] : "";
              axiosThis.nominee2.g2_proofType = data["guardian2"]["Guardian_doc_type2"] ? data["guardian2"]["Guardian_doc_type2"] : "AADHAR";
              axiosThis.nominee2.g2_pan = data["guardian2"]["Guardian_PAN2"] ? data["guardian2"]["Guardian_PAN2"] : "";

              if (data["guardian2"]["Guardian_proof2"]) {
                let proofPath = data["guardian2"]["Guardian_proof2"];
                if (!proofPath.startsWith("http")) {
                   axiosThis.nominee2.g2_proof = api.api_url + `/filsend?path=${proofPath}`;
                } else {
                   axiosThis.nominee2.g2_proof = proofPath;
                }
              }
            }
          }

          if (data["nominee3"]) {
            axiosThis.nominee3.n3_name = data["nominee3"]["Nom3_name"];
            axiosThis.nominee3.n3_dob = data["nominee3"]["Nom3_DOB"];
            axiosThis.nominee3.n3_relation = data["nominee3"]["Nom3_relation"];
            if (Object.prototype.hasOwnProperty.call(data["nominee3"], "Nom3_percent_feild1")) {
              axiosThis.nominee3.n3_percent = data["nominee3"]["Nom3_percent_feild1"];
            }
            axiosThis.nominee3.n3_email = data["nominee3"]["Nom3_email"];
            axiosThis.nominee3.n3_mobile = data["nominee3"]["Nom3_mobile"];
            axiosThis.nominee3.n3_addr = data["nominee3"]["Nom3_address1"];
            axiosThis.nominee3.n3_city = data["nominee3"]["Nom3_city"];
            axiosThis.nominee3.n3_state = data["nominee3"]["Nom3_state"];
            axiosThis.nominee3.n3_country = data["nominee3"]["Nom3_country"];
            axiosThis.nominee3.n3_pincode = data["nominee3"]["Nom3_pincode"];
            axiosThis.nominee3.n3_proofType = data["nominee3"]["nom3_doc_type"];
            axiosThis.nominee3.n3_pan = data["nominee3"]["Nom3_PAN"];
            axiosThis.nominee3.n3_hold_print = data["nominee3"]["Nom3_hold_print"] || "";
            axiosThis.nominee3.n3_addrCB = data["nominee3"]["Nom3_addrCB"] == "True" ? true : false;
            axiosThis.nominee3.n3_age = data["nominee3"]["Nom3_age"] == "True" ? true : false;
            axiosThis.activetab = Number(axiosThis.nominee3.n3_percent) > 0 ? "tab3" : axiosThis.activetab;

            if (data["guardian3"]) {
              axiosThis.nominee3.g3_name = data["guardian3"]["Guardian_name3"] ? data["guardian3"]["Guardian_name3"] : "";
              axiosThis.nominee3.g3_dob = data["guardian3"]["Guardian_dob3"] ? data["guardian3"]["Guardian_dob3"] : "";
              axiosThis.nominee3.g3_relation = data["guardian3"]["Guardian_relation3"] ? data["guardian3"]["Guardian_relation3"] : "";
              axiosThis.nominee3.g3_addrCB = data["guardian3"]["Guardian_addrCB3"] == "True" ? true : false;
              axiosThis.nominee3.g3_addr = data["guardian3"]["Guardian_address3"] ? data["guardian3"]["Guardian_address3"] : "";
              axiosThis.nominee3.g3_city = data["guardian3"]["Guardian_city3"] ? data["guardian3"]["Guardian_city3"] : "";
              axiosThis.nominee3.g3_state = data["guardian3"]["Guardian_state3"] ? data["guardian3"]["Guardian_state3"] : "";
              axiosThis.nominee3.g3_country = data["guardian3"]["Guardian_country3"] ? data["guardian3"]["Guardian_country3"] : "";
              axiosThis.nominee3.g3_pincode = data["guardian3"]["Guardian_pincode3"] ? data["guardian3"]["Guardian_pincode3"] : "";
              axiosThis.nominee3.g3_proofType = data["guardian3"]["Guardian_doc_type3"] ? data["guardian3"]["Guardian_doc_type3"] : "AADHAR";
              axiosThis.nominee3.g3_pan = data["guardian3"]["Guardian_PAN3"] ? data["guardian3"]["Guardian_PAN3"] : "";

              if (data["guardian3"]["Guardian_proof3"]) {
                let proofPath = data["guardian3"]["Guardian_proof3"];
                if (!proofPath.startsWith("http")) {
                   axiosThis.nominee3.g3_proof = api.api_url+`/filsend?path=${proofPath}`;
                } else {
                   axiosThis.nominee3.g3_proof = proofPath;
                }
              }
            }
          }

          // Dynamic nominees loading
          axiosThis.additionalNominees = [];
          for (let i = 4; i <= 10; i++) {
            if (data[`nominee${i}`]) {
              let nData = data[`nominee${i}`];
              let gData = data[`guardian${i}`] || {};
              
              let guardianProofPath = gData[`Guardian_proof${i}`] || "";
              let formattedProof = "";
              if (guardianProofPath) {
                 formattedProof = guardianProofPath.startsWith("http") ? guardianProofPath : api.api_url + `/filsend?path=${guardianProofPath}`;
              }

              let newNominee = {
                name: nData[`Nom${i}_name`],
                dob: nData[`Nom${i}_DOB`],
                relation: nData[`Nom${i}_relation`],
                percent: Object.prototype.hasOwnProperty.call(nData, `Nom${i}_percent_feild1`) ? nData[`Nom${i}_percent_feild1`] : "",
                email: nData[`Nom${i}_email`],
                mobile: nData[`Nom${i}_mobile`],
                addr: nData[`Nom${i}_address1`],
                city: nData[`Nom${i}_city`],
                state: nData[`Nom${i}_state`],
                country: nData[`Nom${i}_country`],
                pincode: nData[`Nom${i}_pincode`],
                proofType: nData[`nom${i}_doc_type`],
                proof: nData[`Nom${i}_PAN`],
                hold_print: nData[`Nom${i}_hold_print`] || "",
                addrCB: nData[`Nom${i}_addrCB`] == "True",
                age: nData[`Nom${i}_age`] == "True",

                g_name: gData[`Guardian_name${i}`] || "",
                g_dob: gData[`Guardian_dob${i}`] || "",
                g_relation: gData[`Guardian_relation${i}`] || "",
                g_addrCB: gData[`Guardian_addrCB${i}`] == "True",
                g_addr: gData[`Guardian_address${i}`] || "",
                g_city: gData[`Guardian_city${i}`] || "",
                g_state: gData[`Guardian_state${i}`] || "",
                g_country: gData[`Guardian_country${i}`] || "",
                g_pincode: gData[`Guardian_pincode${i}`] || "",
                g_proofType: gData[`Guardian_doc_type${i}`] || "",
                g_pan: gData[`Guardian_PAN${i}`] || "",
                g_proof: formattedProof,

                menu_dob: false,
                menu_g_dob: false
              };
              axiosThis.additionalNominees.push(newNominee);
            }
          }
          if (axiosThis.nom == "Yes" && axiosThis.nominee1.n1_percent == "") {
            axiosThis.nominee1.n1_percent = 100;
          }
          axiosThis.cardloader = false;
          axiosThis.getSameaddress();
          // Saved nominees present in this application -> don't pre-fill over them.
          // A re-KYC client can get an empty-but-present nominee1 object, so check
          // for a real saved name, not just the key's presence.
          axiosThis.boHasSaved = !!(data["nominee1"] && data["nominee1"]["Nom1_name"] && String(data["nominee1"]["Nom1_name"]).trim());
          axiosThis.boSavedChecked = true;
          axiosThis.tryBoPrefill();
        })
        .catch(function (error) {
          console.log(error);
          axiosThis.boSavedChecked = true;
          axiosThis.boHasSaved = false;
          axiosThis.tryBoPrefill();
          axiosThis.$emit("snack", 0, error);
        });
    },

  },

  computed: {
    relationitems1() {
      const disableForSingle = [
        "Son", "Daughter", "Husband", "Wife", "Grand-Son", "Grand-Daughter"
      ];
      return this.relationitems.map(item => ({
        text: item,
        value: item,
        disabled: this.getstatresponce.marital_status === 'single' && disableForSingle.includes(item)
      }));
    },
    n1_nameErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_name.$dirty) return errors;
      !this.$v.nominee1.n1_name.required && errors.push("Mandatory Field");
      !this.$v.nominee1.n1_name.minLength && errors.push("Must be valid");
      return errors;
    },
    g1_nameErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_name.$dirty) return errors;
      !this.$v.nominee1.g1_name.required && errors.push("Mandatory Field");
      !this.$v.nominee1.g1_name.minLength && errors.push("Name must be at least 3 characters");
      !this.$v.nominee1.g1_name.alphabetsOnly && errors.push("Only alphabets and spaces are allowed");
      return errors;
    },
    n1_dobErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_dob.$dirty) return errors;
      !this.$v.nominee1.n1_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_relationErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_relation.$dirty) return errors;
      !this.$v.nominee1.n1_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_percentErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_percent.$dirty) return errors;
      !this.$v.nominee1.n1_percent.between && errors.push("Enter valid share");
      !this.$v.nominee1.n1_percent.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_addrErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_addr.$dirty) return errors;
      !this.$v.nominee1.n1_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee1.n1_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_cityErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_city.$dirty) return errors;
      !this.$v.nominee1.n1_city.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_stateErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_state.$dirty) return errors;
      !this.$v.nominee1.n1_state.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_countryErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_country.$dirty) return errors;
      !this.$v.nominee1.n1_country.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_pincode.$dirty) return errors;
      !this.$v.nominee1.n1_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee1.n1_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_dobErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_dob.$dirty) return errors;
      !this.$v.nominee1.g1_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_relationErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_relation.$dirty) return errors;
      !this.$v.nominee1.g1_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_proofErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_proof || !this.$v.nominee1.g1_proof.$dirty) return errors;
      !this.$v.nominee1.g1_proof.required && errors.push("Mandatory Field");
      !this.$v.nominee1.g1_proof.validFileType && errors.push("Only PDF, JPG, PNG files are allowed");
      !this.$v.nominee1.g1_proof.validFileSize && errors.push("File size must be less than 5MB");
      return errors;
    },
    g1_idproofErrors() {
      const errors = [];
      const field = this.$v?.nominee1?.g1_proofType;
      if (!field || !field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },
    g1_panErrors() {
      const errors = [];
      const field = this.$v?.nominee1?.g1_pan;
      if (!field || !field.$dirty) return errors;
      if (!field.required) { errors.push("Proof value is required"); return errors; }
      if (!field.conditionalFormat) {
        switch (this.nominee1.g1_proofType) {
          case "PAN":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "AADHAR":
            errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
            break;
          case "PROOF OF IDENTITY":
            errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
            break;
          case "PASSPORT":
            errors.push("Invalid Passport format (e.g. A1234567)");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },
    g1_addrErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_addr.$dirty) return errors;
      !this.$v.nominee1.g1_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee1.g1_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_cityErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_city.$dirty) return errors;
      !this.$v.nominee1.g1_city.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_stateErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_state.$dirty) return errors;
      !this.$v.nominee1.g1_state.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_countryErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_country.$dirty) return errors;
      !this.$v.nominee1.g1_country.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_pincode.$dirty) return errors;
      !this.$v.nominee1.g1_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee1.g1_pincode.required && errors.push("Mandatory Field");
      return errors;
    },

    n2_nameErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_name.$dirty) return errors;
      !this.$v.nominee2.n2_name.required && errors.push("Mandatory Field");
      !this.$v.nominee2.n2_name.minLength && errors.push("Must be valid");
      return errors;
    },
    g2_nameErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_name.$dirty) return errors;
      !this.$v.nominee2.g2_name.required && errors.push("Mandatory Field");
      !this.$v.nominee2.g2_name.minLength && errors.push("Must be valid");
      return errors;
    },
    n2_dobErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_dob.$dirty) return errors;
      !this.$v.nominee2.n2_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_relationErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_relation.$dirty) return errors;
      !this.$v.nominee2.n2_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_percentErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_percent.$dirty) return errors;
      !this.$v.nominee2.n2_percent.between && errors.push("Enter valid share");
      !this.$v.nominee2.n2_percent.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_addrErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_addr.$dirty) return errors;
      !this.$v.nominee2.n2_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee2.n2_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_cityErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_city.$dirty) return errors;
      !this.$v.nominee2.n2_city.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_stateErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_state.$dirty) return errors;
      !this.$v.nominee2.n2_state.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_countryErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_country.$dirty) return errors;
      !this.$v.nominee2.n2_country.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_pincode.$dirty) return errors;
      !this.$v.nominee2.n2_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee2.n2_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_dobErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_dob.$dirty) return errors;
      !this.$v.nominee2.g2_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_relationErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_relation.$dirty) return errors;
      !this.$v.nominee2.g2_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_proofErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_proof || !this.$v.nominee2.g2_proof.$dirty) return errors;
      !this.$v.nominee2.g2_proof.required && errors.push("Mandatory Field");
      !this.$v.nominee2.g2_proof.validFileType && errors.push("Only PDF, JPG, PNG files are allowed");
      !this.$v.nominee2.g2_proof.validFileSize && errors.push("File size must be less than 5MB");
      return errors;
    },
    g2_idproofErrors() {
      const errors = [];
      const field = this.$v?.nominee2?.g2_proofType;
      if (!field || !field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },
    g2_panErrors() {
      const errors = [];
      const field = this.$v?.nominee2?.g2_pan;
      if (!field || !field.$dirty) return errors;
      if (!field.required) { errors.push("Proof value is required"); return errors; }
      if (!field.conditionalFormat) {
        switch (this.nominee2.g2_proofType) {
          case "PAN":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "AADHAR":
            errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
            break;
          case "PROOF OF IDENTITY":
            errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
            break;
          case "PASSPORT":
            errors.push("Invalid Passport format (e.g. A1234567)");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },
    g2_addrErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_addr.$dirty) return errors;
      !this.$v.nominee2.g2_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee2.g2_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_cityErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_city.$dirty) return errors;
      !this.$v.nominee2.g2_city.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_stateErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_state.$dirty) return errors;
      !this.$v.nominee2.g2_state.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_countryErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_country.$dirty) return errors;
      !this.$v.nominee2.g2_country.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_pincode.$dirty) return errors;
      !this.$v.nominee2.g2_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee2.g2_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_nameErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_name.$dirty) return errors;
      !this.$v.nominee3.n3_name.required && errors.push("Mandatory Field");
      !this.$v.nominee3.n3_name.minLength && errors.push("Must be valid");
      return errors;
    },
    g3_nameErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_name.$dirty) return errors;
      !this.$v.nominee3.g3_name.required && errors.push("Mandatory Field");
      !this.$v.nominee3.g3_name.minLength && errors.push("Name must be at least 3 characters");
      !this.$v.nominee3.g3_name.alphabetsOnly && errors.push("Only alphabets and spaces are allowed");
      return errors;
    },
    n3_dobErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_dob.$dirty) return errors;
      !this.$v.nominee3.n3_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_relationErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_relation.$dirty) return errors;
      !this.$v.nominee3.n3_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_percentErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_percent.$dirty) return errors;
      !this.$v.nominee3.n3_percent.between && errors.push("Enter valid share");
      !this.$v.nominee3.n3_percent.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_addrErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_addr.$dirty) return errors;
      !this.$v.nominee3.n3_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee3.n3_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_cityErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_city.$dirty) return errors;
      !this.$v.nominee3.n3_city.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_stateErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_state.$dirty) return errors;
      !this.$v.nominee3.n3_state.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_countryErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_country.$dirty) return errors;
      !this.$v.nominee3.n3_country.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_pincode.$dirty) return errors;
      !this.$v.nominee3.n3_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee3.n3_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_dobErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_dob.$dirty) return errors;
      !this.$v.nominee3.g3_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_relationErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_relation.$dirty) return errors;
      !this.$v.nominee3.g3_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_proofErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_proof || !this.$v.nominee3.g3_proof.$dirty) return errors;
      !this.$v.nominee3.g3_proof.required && errors.push("Mandatory Field");
      !this.$v.nominee3.g3_proof.validFileType && errors.push("Only PDF, JPG, PNG files are allowed");
      !this.$v.nominee3.g3_proof.validFileSize && errors.push("File size must be less than 5MB");
      return errors;
    },
    g3_idproofErrors() {
      const errors = [];
      const field = this.$v?.nominee3?.g3_proofType;
      if (!field || !field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },
    g3_panErrors() {
      const errors = [];
      const field = this.$v?.nominee3?.g3_pan;
      if (!field || !field.$dirty) return errors;
      if (!field.required) { errors.push("Proof value is required"); return errors; }
      if (!field.conditionalFormat) {
        switch (this.nominee3.g3_proofType) {
          case "PAN":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "AADHAR":
            errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
            break;
          case "PROOF OF IDENTITY":
            errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
            break;
          case "PASSPORT":
            errors.push("Invalid Passport format (e.g. A1234567)");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },
    g3_addrErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_addr.$dirty) return errors;
      !this.$v.nominee3.g3_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee3.g3_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_cityErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_city.$dirty) return errors;
      !this.$v.nominee3.g3_city.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_stateErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_state.$dirty) return errors;
      !this.$v.nominee3.g3_state.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_countryErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_country.$dirty) return errors;
      !this.$v.nominee3.g3_country.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_pincode.$dirty) return errors;
      !this.$v.nominee3.g3_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee3.g3_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_mobileerror() {
      const errors = [];
      const mobile = this.$v.nominee1.n1_mobile;
      if (!mobile || !mobile.$dirty) return errors;
      if (!mobile.required) {
        errors.push("Mobile number is required");
        return errors;
      }
      if (!mobile.startsWithValidDigit) {
        errors.push("Mobile number must start with 6, 7, 8 or 9");
      }
      if (!mobile.minLength || !mobile.maxLength) {
        errors.push("Mobile number must be exactly 10 digits");
      }
      return errors;
    },


    n1_emailerror() {
      const errors = [];
      const email = this.$v.nominee1.n1_email;

      if (!email || !email.$dirty) return errors;

      if (!email.required) {
        errors.push("Email is required");
      }

      if (!email.strictEmail) {
        errors.push("Enter a valid email address");
      }

      return errors;
    },
    n2_mobileerror() {
      const errors = [];
      const mobile = this.$v.nominee2.n2_mobile;
      if (!mobile || !mobile.$dirty) return errors;
      if (!mobile.required) {
        errors.push("Mobile number is required");
        return errors;
      }
      if (!mobile.startsWithValidDigit) {
        errors.push("Mobile number must start with 6, 7, 8 or 9");
      }
      if (!mobile.minLength || !mobile.maxLength) {
        errors.push("Mobile number must be exactly 10 digits");
      }
      return errors;
    },
    n2_emailerror() {
      const errors = [];
      const email = this.$v.nominee2.n2_email;
      if (!email || !email.$dirty) return errors;
      if (!email.required) {
        errors.push("Email is required");
      }
      if (!email.strictEmail) {
        errors.push("Enter a valid email address");
      }
      return errors;
    },
    isDynamicNomineesValid() {
      if (this.additionalNominees.length === 0) return true;
      return this.additionalNominees.every((n, index) => {
        let valid = n.name && n.percent && n.dob && n.relation && n.proofType && n.proof && n.mobile && n.email;
        if (!valid) {
          console.log(`Dynamic Nominee ${index + 4} basic fields missing:`, {
            name: n.name, percent: n.percent, dob: n.dob, relation: n.relation,
            proofType: n.proofType, proof: n.proof, mobile: n.mobile, email: n.email
          });
          return false;
        }
        // Validate Proof Type and Proof Value
        if (!n.proofType) {
          console.log(`Dynamic Nominee ${index + 4} proof type missing`);
          return false;
        }
        if (!n.proof) {
          console.log(`Dynamic Nominee ${index + 4} proof value missing`);
          return false;
        }

        // Validate Proof Format
        let isProofValid = false;
        if (n.proofType === 'PAN') {
          isProofValid = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(n.proof);
        } else if (n.proofType === 'AADHAR') {
          isProofValid = /^\d{4}$/.test(n.proof) && /[1-9]/.test(n.proof);
        } else if (n.proofType === 'PROOF OF IDENTITY') {
          isProofValid = /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/.test(n.proof);
        } else if (n.proofType === 'PASSPORT') {
          isProofValid = /^[A-Z][0-9]{7}$/.test(n.proof);
        }

        if (!isProofValid) {
          console.log(`Dynamic Nominee ${index + 4} invalid proof format for ${n.proofType}: ${n.proof}`);
          return false;
        }

        if (!n.addrCB) {
          if (!n.addr || !n.city || !n.state || !n.country || !n.pincode) {
            console.log(`Dynamic Nominee ${index + 4} address missing`);
            return false;
          }
        }
        if (n.age) {
          if (!n.g_name || !n.g_dob || !n.g_relation) {
            console.log(`Dynamic Nominee ${index + 4} guardian basic missing`);
            return false;
          }
          if (!n.g_proofType || !n.g_pan) {
            console.log(`Dynamic Nominee ${index + 4} guardian proof missing`);
            return false;
          }
          let isGProofValid = false;
          if (n.g_proofType === 'PAN') {
            isGProofValid = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(n.g_pan);
          } else if (n.g_proofType === 'AADHAR') {
            isGProofValid = /^\d{4}$/.test(n.g_pan) && /[1-9]/.test(n.g_pan);
          } else if (n.g_proofType === 'PROOF OF IDENTITY') {
            isGProofValid = /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/.test(n.g_pan);
          } else if (n.g_proofType === 'PASSPORT') {
            isGProofValid = /^[A-Z][0-9]{7}$/.test(n.g_pan);
          }
          if (!isGProofValid) {
            console.log(`Dynamic Nominee ${index + 4} guardian proof invalid for ${n.g_proofType}: ${n.g_pan}`);
            return false;
          }
          if (!n.g_addrCB) {
            if (!n.g_addr || !n.g_city || !n.g_state || !n.g_country || !n.g_pincode) {
              console.log(`Dynamic Nominee ${index + 4} guardian address missing`);
              return false;
            }
          }
        }
        return true;
      });
    },

    isTotalPercentValid() {
      let n1 = Number(this.nominee1.n1_percent) || 0;
      let n2 = Number(this.nominee2.n2_percent) || 0;
      let n3 = Number(this.nominee3.n3_percent) || 0;
      let dynamicTotal = this.additionalNominees.reduce((sum, n) => sum + (Number(n.percent) || 0), 0);

      let total = n1 + dynamicTotal;
      if (this.activetab == 'tab2' || this.activetab == 'tab3') {
        total += n2;
      }
      if (this.activetab == 'tab3') {
        total += n3;
      }

      const isValid = Math.abs(total - 100) < 0.1;
      if (!isValid) {
        console.log(`Total Percentage Invalid: ${total}% (N1:${n1}, N2:${n2}, N3:${n3}, Dyn:${dynamicTotal})`);
      }
      return isValid;
    },

    isFormInvalid() {
      if (this.cardloader) {
        console.log("Form Invalid: Cardloader is active");
        return true;
      }
      if (this.$v.nominee1.$invalid) {
        console.log("Form Invalid: Nominee 1 Invalid", this.$v.nominee1);
        return true;
      }

      if (this.activetab == 'tab2' || this.activetab == 'tab3') {
        if (this.$v.nominee2.$invalid) {
          console.log("Form Invalid: Nominee 2 Invalid");
          return true;
        }
      }

      if (this.activetab == 'tab3') {
        if (this.$v.nominee3.$invalid) {
          console.log("Form Invalid: Nominee 3 Invalid", this.$v.nominee3);
          return true;
        }
      }

      if (!this.isDynamicNomineesValid) {
        console.log("Form Invalid: Dynamic Nominees Invalid");
        return true;
      }

      if (!this.isTotalPercentValid) {
        console.log("Form Invalid: Total Percent Invalid");
        return true;
      }

      if (this.$v.holdPrint.$invalid) {
        console.log("Form Invalid: Statement print preference not selected");
        return true;
      }

      return false;
    },

    holdPrintErrors() {
      const errors = [];
      if (!this.$v.holdPrint.$dirty) return errors;
      !this.$v.holdPrint.required && errors.push("Please select one option");
      return errors;
    },
    formErrorSummary() {
      if (this.cardloader) return "Processing...";
      const errors = [];
      if (this.$v.nominee1.$invalid) errors.push("Nominee 1: " + this.getMissingFields(this.$v.nominee1, 'n1'));
      if ((this.activetab == 'tab2' || this.activetab == 'tab3') && this.$v.nominee2.$invalid) errors.push("Nominee 2: " + this.getMissingFields(this.$v.nominee2, 'n2'));
      if (this.activetab == 'tab3' && this.$v.nominee3.$invalid) errors.push("Nominee 3: " + this.getMissingFields(this.$v.nominee3, 'n3'));
      if (this.$v.holdPrint.$invalid) errors.push("Nomination details to be printed in the account / holding statements required");
      if (!this.isDynamicNomineesValid) errors.push("Please check additional nominee details");
      if (!this.isTotalPercentValid) errors.push("Total percentage must be 100%");
      return errors.join(' | ');
    },

    n3_mobileerror() {
      const errors = [];
      const mobile = this.$v.nominee3.n3_mobile;
      if (!mobile || !mobile.$dirty) return errors;
      if (!mobile.required) {
        errors.push("Mobile number is required");
        return errors;
      }
      if (!mobile.startsWithValidDigit) {
        errors.push("Mobile number must start with 6, 7, 8 or 9");
      }
      if (!mobile.minLength || !mobile.maxLength) {
        errors.push("Mobile number must be exactly 10 digits");
      }
      return errors;
    },

    n3_emailerror() {
      const errors = [];
      const email = this.$v.nominee3.n3_email;
      if (!email || !email.$dirty) return errors;
      if (!email.required) {
        errors.push("Email is required");
      }
      if (!email.strictEmail) {
        errors.push("Enter a valid email address");
      }
      return errors;
    },
    n1_idproofErrors() {
      const errors = [];
      const field = this.$v?.nominee1?.n1_proofType;
      if (!field || !field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },

    n1_proofErrors() {
      const errors = [];
      const field = this.$v.nominee1.n1_pan;
      if (!field.$dirty) return errors;
      if (!field.required) { errors.push("Proof value is required"); return errors; }

      if (!field.conditionalFormat) {
        switch (this.nominee1.n1_proofType) {
          case "PAN":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "AADHAR":
            errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
            break;
          case "PROOF OF IDENTITY":
            errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
            break;
          case "PASSPORT":
            errors.push("Invalid Passport format (e.g. A1234567)");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },

    n2_idproofErrors() {
      const errors = [];
      const field = this.$v.nominee2.n2_proofType;
      if (!field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },
    n2_proofErrors() {
      const errors = [];
      const field = this.$v.nominee2.n2_pan;
      if (!field.$dirty) return errors;
      if (!field.required) { errors.push("Proof value is required"); return errors; }

      if (!field.conditionalFormat) {
        switch (this.nominee2.n2_proofType) {
          case "PAN":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "AADHAR":
            errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
            break;
          case "PROOF OF IDENTITY":
            errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
            break;
          case "PASSPORT":
            errors.push("Invalid Passport format (e.g. A1234567)");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },

    n3_idproofErrors() {
      const errors = [];
      const field = this.$v.nominee3.n3_proofType;
      if (!field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },
    n3_proofErrors() {
      const errors = [];
      const field = this.$v.nominee3.n3_pan;
      if (!field.$dirty) return errors;
      if (!field.required) { errors.push("Proof value is required"); return errors; }

      if (!field.conditionalFormat) {
        switch (this.nominee3.n3_proofType) {
          case "PAN":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "AADHAR":
            errors.push("Enter valid last 4 digits of Aadhaar (0000 not allowed)");
            break;
          case "PROOF OF IDENTITY":
            errors.push("Invalid Driving Licence format (e.g. TN0120230000123)");
            break;
          case "PASSPORT":
            errors.push("Invalid Passport format (e.g. A1234567)");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },




  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.getSameaddress();
    this.hypervegenonres = []
    this.dataloader = true;
    var axiosThis = this;
    var json_data = {
      mobile: atob(localStorage.getItem("hash")),
    };
    var config = {
      method: "post",
      url: api.api_url + "/signupGetUserPersonalDetails",
      headers: { "Content-Type": "application/json", "mobile": atob(localStorage.getItem("hash")) },
      data: JSON.stringify(json_data),
    };
    axios(config)
      .then(function (response) {
        var data = response.data;
        // console.log("mounted", axiosThis.getstatresponce);
        // console.log("mounted111", axiosThis.getstatresponce.data_type);
        console.log("mounted2222", axiosThis.getstatresponce);
        axiosThis.hypervegenonres = response.data

        if (data) {
          if (data["nominee_check"] == "Yes") {
            axiosThis.getNomineedata();
            axiosThis.nomis = 1;
          }
          else if (
            data["nominee_check"] === "No" &&
            data["hyv_nm_path"] != '' && data["hyv_nm_path"] != null && data["hyv_nm_path"] != undefined && (axiosThis.getstatresponce && axiosThis.getstatresponce.app_status != "rejected")
          ) {
            console.log("moneeeeeeeeee");
            axiosThis.mainnomineeselect = false
            axiosThis.hypervegestarted = false
            axiosThis.hypervergeresult = true
            // axiosThis.hypervergresdata = axiosThis.getstatresponce.data_type.nomineehyper
          }

          axiosThis.nom = data["nominee_check"];
          if (data["nominee_check"] != "Yes") {
            // Nothing opted-in/saved in this application -> eligible for back-office pre-fill.
            axiosThis.boSavedChecked = true;
            axiosThis.boHasSaved = false;
            axiosThis.tryBoPrefill();
          }
          axiosThis.nomineedata = data;
        }
        axiosThis.cardloader = false;
        axiosThis.dataloader = false;
      })
      .catch(function (error) {
        console.log(error);
        // Couldn't read personal details -> assume nothing saved so a re-active
        // client can still be pre-filled from back office.
        axiosThis.boSavedChecked = true;
        axiosThis.boHasSaved = false;
        axiosThis.tryBoPrefill();
        axiosThis.$emit("snack", 0, error);
      });
  },
};
</script>
<style>
@media (min-width: 100px) and (max-width: 500px) {
  .smalldev {
    margin-top: 24px !important;
  }
}
</style>